

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  CircularProgress,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  Collapse,
  TextField,
  Input,
  Tooltip,
  IconButton,
  Button,
  Box,
  InputAdornment,
  Autocomplete,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Typography,
  Modal,
} from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  Delete,
  FileCopy,
  Edit,
  Save,
  Close,
} from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useAuth } from '../../auth/Auth';
import { usePermission } from '../../auth/usePermission';
import { useModuleEntitlements } from '../../hooks/useModuleEntitlements';
import { getApiErrorMessage, isModuleNotEntitledError } from '../../utils/apiErrors';
import InfoIcon from '@mui/icons-material/Info';
import InlineEditField from 'components/CustonEditableInlineField/CustomEditableInlineField';
import { Email, PictureAsPdf } from '@mui/icons-material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Invoice from './quotation_pdf';
import AttachmentUploadModal from 'components/CustomModals/AttachmentUploadModal';
import Attachments from 'layouts/dashboard/components/Attachments';
import EmailModal from 'components/EmailModal/index.js';
import DeleteIcon from '@mui/icons-material/Delete';
import CloneQuotationModal from 'components/CloneQuotationModal/CloneQuotationModal';
import { formatDate } from 'utils/DateTimeConversion';
import { useTheme } from '@mui/material/styles';
import { serializeEmailAttachments } from 'utils/emailAttachments';
import Popper from '@mui/material/Popper';  // Import Popper component
import { Link } from 'react-router-dom';
import CustomFieldsSection from 'components/CustomFields/CustomFieldsSection';
import DataLoadingSpinner from "components/Spinners/DataLoadingSpinner";

import { useSnackbar } from 'notistack';
import colors from "assets/theme/base/colors";
import { downloadPrivateObject, uploadPrivateObject } from 'utils/S3';
import ActivityModal from 'components/CustomModals/CustomActivityModal';
import Activities from 'layouts/dashboard/components/Activities';
import EventIcon from '@mui/icons-material/Event';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { useCurrency } from '../../context/CurrencyContext';
import { frontendLogger } from '../../utils/logger';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import EchoComposer from 'components/EchoComposer/EchoComposer';
import MDUserAvatar from 'components/MDUserAvatar';
import { Avatar } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import RecordPageV2, { TabStack } from "components/v2/record/RecordPageV2";
import { HeroBadge } from "components/v2/record/RecordHero";
import { StatusBadge } from "layouts/crm/account360/RelatedList";
import ActivityTimeline from "layouts/crm/account360/ActivityTimeline";
import { relativeTime } from "layouts/crm/account360/format";
import { Briefcase, Building2, CalendarDays, CircleDollarSign, CircleDot, Clock, FileText, History, LayoutGrid, ListOrdered, Paperclip } from "lucide-react";

// Add these mappings for transport and vehicle types
const transportModeMapping = {
  '1': 'Road',
  '2': 'Rail',
  '3': 'Air',
  '4': 'Ship',
};

const vehicleTypeMapping = {
  'R': 'Regular',
  'C': 'Container',
  'O': 'Over Dimensional Cargo',
  // Add other mappings as needed
};

function QuotationDetail() {
  const { id } = useParams();
  const { getDealCurrency, getCurrencySymbol, formatCurrency } = useCurrency();
  const { user, axiosInstance } = useAuth();
  const { isSupportUser } = usePermission('quotations');
  // UI v2 record layout (design-reference "Sales · Deal record").
  const isV2 = useTheme()?.pearlUi === 'v2';
  const { isModuleEnabled, loading: entitlementsLoading } = useModuleEntitlements();
  const hasTasksModule = isModuleEnabled('TASKS');
  const [quotation, setQuotation] = useState(null);
  const [quotationItems, setQuotationItems] = useState([]);
  const [purchaseOrder, setPurchaseOrder] = useState(null);
  const [salesOrder, setSalesOrder] = useState(null);
  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [poNumber, setPoNumber] = useState('');
  const [soNumber, setSoNumber] = useState('');
  const [poFile, setPoFile] = useState(null);
  const [soFile, setSoFile] = useState(null);
  const [showPoUpload, setShowPoUpload] = useState(false);
  const [showSoUpload, setShowSoUpload] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [updatedFields, setUpdatedFields] = useState({});
  const [editedFields, setEditedFields] = useState({});
  const [isCloneModalOpen, setIsCloneModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCloning, setIsCloning] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [isAttachmentModalOpen, setIsAttachmentModalOpen] = useState(false);
  const navigate = useNavigate();
  const handleOpenDeleteModal = () => setIsDeleteModalOpen(true);
  const handleCloseDeleteModal = () => setIsDeleteModalOpen(false);
  const [isEditCardOpen, setIsEditCardOpen] = useState(false);
  const [products, setProducts] = useState([]); // State for products
  const [isDownloading, setIsDownloading] = useState(false);
  const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);
  const [currentInvoiceHtml, setCurrentInvoiceHtml] = useState('');
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [newEmail, setNewEmail] = useState({ to: '', cc: '', bcc: '', subject: '', content: '' });
  const [isGenerating, setIsGenerating] = useState(false);
  const [isEmailSending, setIsEmailSending] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const [emailContext, setEmailContext] = useState('');
  const [loading, setLoading] = useState(false);
  const [gmailToken, setGmailToken] = useState('YOUR_GOOGLE_API_TOKEN');
  const [composing, setComposing] = useState(false);
  const [editedProducts, setEditedProducts] = useState(new Array(quotationItems.length).fill(false)); // Track edited state
  const [accountList, setAccountList] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [editDialogFields, setEditDialogFields] = useState({});
  const [editDialogAccountOptions, setEditDialogAccountOptions] = useState([]);
  const [accountEmail, setAccountEmail] = useState(''); // State to hold the account email
  const [dealDetails, setDealDetails] = useState(null);
  const [subtotal, setSubtotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isCreateOrderModalOpen, setIsCreateOrderModalOpen] = useState(false);
  const [generatedOrderNumber, setGeneratedOrderNumber] = useState('');
  const [emailAttachments, setEmailAttachments] = useState([]);
  const customFieldsRef = useRef(null); // Added to state declarations
  const [downloadLoadingId, setDownloadLoadingId] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [isCloneLoading, setIsCloneLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDealLoading, setIsDealLoading] = useState(false);
  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false);
  const [activities, setActivities] = useState([]);
  const [dealCurrency, setDealCurrency] = useState('INR'); // Default currency
  const [newActivity, setNewActivity] = useState({
    quote_id: id,
    type: '',
    description: '',
    date: new Date().toISOString().split('T')[0],
  });
  const [isActivitiesLoading, setIsActivitiesLoading] = useState(false);
  // 1. Add state for section preferences
  const [sectionOrder, setSectionOrder] = useState([]);
  const [hiddenSections, setHiddenSections] = useState([]);
  const [loadingSections, setLoadingSections] = useState(true);

  // State for unit price editing in edit modal
  const [editingPriceIndex, setEditingPriceIndex] = useState(null);
  const [editingPriceValue, setEditingPriceValue] = useState('');

  // Echo/Feed functionality state variables
  const [feedItems, setFeedItems] = useState([]);
  const [isFeedLoading, setIsFeedLoading] = useState(false);
  const [editingFeedItem, setEditingFeedItem] = useState(null);
  const [editFeedContent, setEditFeedContent] = useState('');
  const [isEditingFeed, setIsEditingFeed] = useState(false);
  const [isEchoModalOpen, setIsEchoModalOpen] = useState(false);
  const [newEchoContent, setNewEchoContent] = useState('');
  const [isCreatingEcho, setIsCreatingEcho] = useState(false);
  const [nameCache, setNameCache] = useState({});
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
  ];

  const [customFields, setCustomFields] = useState([]);

  useEffect(() => {
    fetchQuotationDetails();
    fetchOrderDetails();
    fetchAttachments();
    fetchAccountList();
  }, [id]);

  useEffect(() => {
    if (entitlementsLoading || !id) return;
    if (hasTasksModule) {
      fetchActivities();
    } else {
      setActivities([]);
    }
  }, [id, entitlementsLoading, hasTasksModule]);

  // 2. Fetch section preferences on mount and on tab focus
  useEffect(() => {
    const fetchSectionPreferences = async () => {
      try {
        const res = await axiosInstance.get('/preferences/global');
        const prefs = res.data?.section_preferences?.quotation;
        if (prefs) {
          if (prefs.order) setSectionOrder(prefs.order);
          if (prefs.hidden) setHiddenSections(prefs.hidden);
        } else {
          setSectionOrder([
            'Quotation Information',
            // 'Shipping & Payment',
            // 'Transport Details',
            'Custom Field Information',
            'Quotation Items',
            'Audit Information',
          ]);
          setHiddenSections([]);
        }
      } catch (e) {
        setSectionOrder([
          'Quotation Information',
          // 'Shipping & Payment',
          // 'Transport Details',
          'Custom Field Information',
          'Quotation Items',
          'Audit Information',
        ]);
        setHiddenSections([]);
      } finally {
        setLoadingSections(false);
      }
    };
    fetchSectionPreferences();
    // Refetch on tab focus
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') fetchSectionPreferences();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [axiosInstance]);

  // Fetch feed items on component mount
  useEffect(() => {
    if (id) {
      fetchFeedItems();
    }
  }, [id]);

  // 3. Compose visible sections in order
  const visibleSections = sectionOrder.filter(key => !hiddenSections.includes(key));

  const handleOpenActivityModal = () => {
    setIsActivityModalOpen(true);
  };

  const handleCloseActivityModal = () => {
    setIsActivityModalOpen(false);
    setNewActivity({
      quote_id: id,
      type: '',
      description: '',
      date: new Date().toISOString().split('T')[0],
    });
  };

  const handleActivitySaved = async (newActivityData) => {
    setIsActivitiesLoading(true);
    try {
      const currentDate = new Date().toISOString();
      setActivities([...activities, newActivityData]);

      const lastActivity = await axiosInstance.patch(`/quote/${id}`, {
        last_activity: currentDate,
      });

      // console.log('Last activity updated:', lastActivity.data);

      setSnackbar({
        open: true,
        message: 'Activity created successfully!',
        severity: 'success',
      });

      await fetchQuotationDetails(); // Refresh lead data to get updated information
    } catch (error) {
      console.error('Error updating last activity:', error);
      setSnackbar({
        open: true,
        message: 'Error updating last activity',
        severity: 'error',
      });
    } finally {
      setIsActivitiesLoading(false);
    }
  };


  const handleDeleteActivity = async (activityId) => {
    setIsLoading(true);
    try {
      await axiosInstance.delete(`/activities/${activityId}`);
      setActivities(activities.filter((activity) => activity.id !== activityId));
      setSnackbar({
        open: true,
        message: 'Activity deleted successfully!',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error deleting activity:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting activity',
        severity: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Unit price editing functions for edit modal
  const handleStartPriceEdit = (index, currentPrice) => {
    setEditingPriceIndex(index);
    setEditingPriceValue(currentPrice.toString());
  };

  const handleCancelPriceEdit = () => {
    setEditingPriceIndex(null);
    setEditingPriceValue('');
  };

  const handleUnitPriceChange = (index, newPrice) => {
    const updatedProducts = [...products];
    const product = updatedProducts[index];
    
    // Update unit price
    product.price = newPrice;
    
    // Recalculate discounted price
    const discountAmount = newPrice * (product.discount_percentage / 100);
    product.discounted_price = (newPrice - discountAmount).toFixed(2);
    
    // Recalculate total price
    const quantity = parseFloat(product.quantity) || 0;
    product.total_price = (parseFloat(product.discounted_price) * quantity).toFixed(2);
    
    setProducts(updatedProducts);
    calculateSubtotal(updatedProducts);
  };

  const handleEditActivity = (updated) => {
    if (!updated?.id) return;
    setActivities((prev) =>
      prev.map((a) => (a.id === updated.id ? { ...a, ...updated } : a)),
    );
  };

  const fetchActivities = async () => {
    if (!hasTasksModule) {
      setActivities([]);
      return;
    }
    console.log('fetchActivities function called');
    // console.log('ID value:', id); // Log the `id` to ensure it has the correct value.

    try {
      const params = new URLSearchParams();

      // Log when parameters are being appended.
      if (true) {
        // console.log('Appending "parent_table" to params with value "orders"');
        params.append('parent_table', 'quotes');
      }
      if (true) {
        // console.log(`Appending "parent_table_id" to params with value "${id}"`);
        params.append('parent_table_id', id);
      }
      const response = await axiosInstance.get('/activities/', {
        params: {
          parent_table: 'quotes',
          parent_table_id: id
        }
      });
      setActivities(response.data || []);
      // console.log('Activities state updated successfully');
    } catch (error) {
      if (isModuleNotEntitledError(error)) {
        setActivities([]);
        return;
      }
      // Log detailed error information
      console.error('Error occurred during fetchActivities execution:', {
        message: error.message,
        name: error.name,
        stack: error.stack,
        config: error.config,
        response: error.response,
      });

      // Check if response is defined and log its details
      if (error.response) {
        console.error('Error response details:', {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data,
        });
      } else {
        console.error('No response received. Possible network error.');
      }

      // Show error notification
      setSnackbar({
        open: true,
        message: getApiErrorMessage(error, 'Error fetching activities'),
        severity: 'error',
      });

      // Clear activities state on error
      setActivities([]);
    }
  };


  const fetchAccountList = async () => {
    try {
      const response = await axiosInstance.get('/accounts/');
      setAccountList(response.data);
      setAccountOptions(response.data.map(account => account.name));
      setEditDialogAccountOptions(response.data.map(account => account.name));
    } catch (error) {
      console.error('Error fetching account list:', error);
    }
  };

  useEffect(() => {
    // Recalculate subtotal whenever quotationItems change
    const newSubtotal = quotationItems.reduce((acc, item) => {
      return acc + (parseFloat(item.total_price) || 0);
    }, 0);

    setSubtotal(newSubtotal); // Update the subtotal state
  }, [quotationItems]);


  const handleEditToggle = () => {
    if (isSupportUser) {
      setSnackbar({
        open: true,
        message: 'Support users are not allowed to edit quotations.',
        severity: 'error',
      });
      return; // Exit the function early
    }

    setIsEditLoading(true);
    try {
      const formattedQuoteDate = quotation.quote_date
        ? new Date(quotation.quote_date).toISOString().split('T')[0]
        : '';

      // Ensure custom fields are included in editedFields
      const customFields = quotation.custom_fields || {};
      setEditedFields({
        ...quotation,
        ...customFields, // Spread custom fields into editedFields
        quote_date: formattedQuoteDate,
      });

      setEditDialogFields({
        ...quotation,
        ...customFields, // Spread custom fields into editDialogFields
        quote_date: formattedQuoteDate,
      });

      setProducts(
        quotationItems.map((item) => ({
          name: item.product_name,
          price: item.price,
          tax_rate: item.tax,
          discount_percentage: item.discount_percentage,
          quantity: item.quantity,
          discounted_price: item.discounted_price,
          total_price: item.total_price,
        }))
      );

      setIsEditCardOpen(true);
    } catch (error) {
      console.error('Error in edit toggle:', error);
    } finally {
      setIsEditLoading(false);
    }
  };

  const handleCloneClick = () => {
    if (isSupportUser) {
      setSnackbar({
        open: true,
        message: 'Support users are not allowed to clone quotations.',
        severity: 'error',
      });
      return; // Exit the function early
    }

    setIsCloneLoading(true);
    try {
      const quotationWithAllData = {
        ...quotation,
        deal_name: quotation.deal_name,
        deal_id: quotation.deal_id,
        quote_date: quotation.quote_date,
        custom_fields: quotation.custom_fields || {}
      };
      setIsCloneModalOpen(true);
    } catch (error) {
      console.error('Error preparing clone:', error);
    } finally {
      setIsCloneLoading(false);
    }
  };

  const handleClone = async () => {
    setIsCloning(true);
    try {
      // Step 1: Generate a unique quote name using the backend endpoint
      const uniqueNameResponse = await axiosInstance.get('/quotations/generate-name');
      const newUniqueName = uniqueNameResponse.data.quote_name;

      // Step 2: Prepare the cloned quotation data
      const clonedQuotation = {
        ...quotation,
        id: undefined, // Remove the ID to create a new entry
        quote_name: newUniqueName, // Use the new unique name
        created_at: new Date().toISOString(), // Set the creation date to now
        updated_at: null, // Reset updated date
      };

      console.log("Cloning quotation with data:", clonedQuotation);

      // Step 3: Send API request to create the cloned quotation
      const quotationResponse = await axiosInstance.post('/quotations/', clonedQuotation);
      const newQuotationId = quotationResponse.data.id; // Get the new quotation ID

      // Step 4: Clone the associated items
      const clonedItems = quotationItems.map(item => ({
        ...item,
        id: undefined, // Remove the ID for line items as well
        quotation_id: newQuotationId, // Assign the new quotation ID to each item
      }));

      // Step 5: Send the cloned items to the API
      await axiosInstance.post(`/quotations/${newQuotationId}/items/`, clonedItems);

      console.log("Cloned quotation response:", quotationResponse.data);

      // Show success snackbar
      setSnackbar({
        open: true,
        message: 'Quotation cloned successfully!',
        severity: 'success',
      });

      // Optionally, you can redirect to the new quotation's detail page
      // navigate(`/quote/detail/${newQuotationId}`);

      // --- Log quotation creation (clone) ---
      await frontendLogger.logCreate('Quotation', {
        id: newQuotationId,
        action: 'clone',
        created_by: user.id,
        user: user.username,
        created_at: quotationResponse.data.created_at || new Date().toISOString(),
      });

    } catch (error) {
      console.error('Error cloning quotation:', error);
      setSnackbar({
        open: true,
        message: 'Failed to clone quotation. Please try again.',
        severity: 'error',
      });
    } finally {
      setIsCloning(false);
    }
  };

  const auditFields = [
    { label: "Created By", field: "created_by_name", userIdField: "created_by", readOnly: true },
    { label: "Modified By", field: "updated_by_name", userIdField: "updated_by", readOnly: true },
    { label: "Created Date", field: "created_at", readOnly: true },
    { label: "Modified Date", field: "updated_at", readOnly: true },
  ];

  const calculateSubtotal = (updatedProducts) => {
    const newSubtotal = updatedProducts.reduce((acc, product) => {
      return acc + (parseFloat(product.total_price) || 0);
    }, 0);
    setSubtotal(newSubtotal); // Update the subtotal state
  };


  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...products];

    // Update the specific field
    updatedProducts[index][field] = value;

    // If product name is being changed/cleared
    if (field === 'name') {
      if (!value) {
        // Reset all related fields when product name is cleared
        updatedProducts[index] = {
          ...updatedProducts[index],
          name: '',
          price: 0,
          tax_rate: 0,
          discount_percentage: 0,
          quantity: 1,
          discounted_price: 0,
          total_price: 0
        };
      } else {
        // If a new product is selected, update with its details
        const selectedProduct = productList.find(p => p.name === value);
        if (selectedProduct) {
          updatedProducts[index] = {
            ...updatedProducts[index],
            price: selectedProduct.price || 0,
            tax_rate: selectedProduct.tax_rate !== undefined
              ? selectedProduct.tax_rate
              : (selectedProduct.tax_percentage || 0),
            // Keep existing quantity and discount
            quantity: updatedProducts[index].quantity || 1,
            discount_percentage: updatedProducts[index].discount_percentage || 0
          };
        }
      }
    }

    // Recalculate discounted price and total price
    const price = parseFloat(updatedProducts[index].price) || 0;
    const discountPercentage = parseFloat(updatedProducts[index].discount_percentage) || 0;
    const quantity = parseFloat(updatedProducts[index].quantity) || 0;

    // Calculate discounted price
    const discountAmount = price * (discountPercentage / 100);
    updatedProducts[index].discounted_price = price - discountAmount;

    // Calculate total price
    updatedProducts[index].total_price = updatedProducts[index].discounted_price * quantity;

    // Update state
    setProducts(updatedProducts);

    // Calculate subtotal as sum of all total_prices
    calculateSubtotal(updatedProducts); // Ensure subtotal is recalculated after product change
  };



  const handleRemoveProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts); // Update state with new products
    calculateSubtotal(updatedProducts); // Recalculate subtotal after removing a product
  };

  const handleAddProduct = () => {
    const newProduct = {
      name: '',
      price: 0,
      tax_rate: 0,
      discount_percentage: 0,
      quantity: 1,
      discounted_price: 0,
      total_price: 0,
    };

    const updatedProducts = [...products, newProduct]; // Add the new product to the list
    setProducts(updatedProducts); // Update state with new products
    calculateSubtotal(updatedProducts); // Recalculate subtotal after adding a new product
  };


  const fetchQuotationDetails = async () => {
    setIsLoading(true);
    try {
      const [quotationResponse, itemsResponse] = await Promise.all([
        axiosInstance.get(`/quotations/${id}`),
        axiosInstance.get(`/quotations/items/${id}`),
      ]);



      const quotationData = quotationResponse.data;
      const dealId = quotationData.deal_id || null; // Get the deal ID from the quotation data
      setDealCurrency(getDealCurrency(dealId));

      // Merge custom fields into the main quotation data
      const mergedQuotationData = {
        ...quotationData,
        ...(quotationData.custom_fields || {}) // Spread custom fields directly into main data
      };

      // Update quotation state with merged data
      setQuotation(mergedQuotationData);

      // Set initial edited fields with merged data
      setEditedFields(mergedQuotationData);

      setQuotationItems(itemsResponse.data);
      setProducts(itemsResponse.data.map(item => ({
        name: item.product_name,
        price: item.price,
        tax_rate: item.tax,
        discount_percentage: item.discount_percentage,
        quantity: item.quantity,
        discounted_price: item.discounted_price,
        total_price: item.total_price,
      })));

    } catch (err) {
      console.error('Error fetching quotation details:', err);
      setError('Failed to fetch quotation details. Please try again.');
      setSnackbar({
        open: true,
        message: 'Failed to fetch quotation details. Please try again.',
        severity: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const fetchCustomFields = async () => {
      try {
        const response = await axiosInstance.get(`/custom-fields/quotations`);
        setCustomFields(response.data || []);
      } catch (error) {
        console.error('Error fetching custom fields:', error);
        setCustomFields([]);
      }
    };

    fetchCustomFields();
  }, []);

  const handleToggleEmailModal = async () => {
    if (!isEmailModalOpen) {
      setIsEmailLoading(true);
      try {
        if (!quotation || !quotation.deal_id) {
          throw new Error('Quotation data is incomplete');
        }

        // Get deal data
        const dealResponse = await axiosInstance.get(`/deals/${quotation.deal_id}`);
        const dealData = dealResponse.data;

        if (!dealData.account_id) {
          throw new Error('No account associated with this deal');
        }

        // Get account data
        const accountResponse = await axiosInstance.get(`/accounts/${dealData.account_id}`);
        const accountEmail = accountResponse.data.email || '';

        // Generate PDF blob
        const pdfBlob = await downloadInvoice(quotation.id, false);
        if (!pdfBlob) {
          throw new Error('Failed to generate PDF');
        }

        // Check file size
        const maxSize = 25 * 1024 * 1024; // 25MB
        if (pdfBlob.size > maxSize) {
          throw new Error('PDF file exceeds 25MB limit');
        }

        // Set email attachments
        setEmailAttachments([{
          filename: `quotation_${quotation.id}.pdf`,
          size: pdfBlob.size,
          content_type: 'application/pdf',
          blob: pdfBlob,
        }]);

        // Set initial email fields
        setNewEmail({
          to: accountEmail,
          cc: '',
          bcc: '',
          subject: `Quotation ${quotation.quote_name}`,
          content: `Please find attached Quotation ${quotation.quote_name}`,
        });

      } catch (error) {
        console.error('Error preparing email:', error);
        setSnackbar({
          open: true,
          message: `Error preparing email: ${error.message}`,
          severity: 'error'
        });
        return; // Don't open modal if there's an error
      }
      finally {
        setIsEmailLoading(false);
      }
    } else {
      setEmailAttachments([]); // Clear attachments when closing
    }

    setIsEmailModalOpen(!isEmailModalOpen);
  };

  const handleGenerateEmail = async () => {
    try {
      setIsGenerating(true);
      setErrorMessage('');

      // Prepare the email context based on the current quotation data
      const emailContext = `
        Quotation Details:
        Quotation ID: ${quotation.id}
        Account Name: ${quotation.account_name}
        Quotation Status: ${quotation.status}
        Subtotal: ${quotation.subtotal}
        Total Amount: ${quotation.total_amount}
  
        Quotation Items:
        ${quotationItems.map((item) => `
          Product Name: ${item.product_name}
          Unit Price: ${item.price}
          Tax %: ${item.tax_rate}%
          Discount %: ${item.discount_percentage}%
          Discounted Price: ${item.discounted_price}
          Quantity: ${item.quantity}
          Total Net Price: ${item.total_price}
        `).join('\n')}
      `;

      // Call the AI-powered email generation service
      const response = await axiosInstance.post('/emails/send', {
        context: emailContext
      });

      if (response.status === 200) {
        const { subject, content } = response.data;
        setNewEmail({
          ...newEmail,
          subject: subject,
          content: content
        });
        setEmailContext('');
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error generating email:', error);
      if (error.response) {
        console.error('Error data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
        setErrorMessage(`Server error: ${error.response.data.detail || error.message}`);
      } else if (error.request) {
        console.error('Error request:', error.request);
        setErrorMessage('No response received from server. Please try again.');
      } else {
        console.error('Error message:', error.message);
        setErrorMessage(`Error: ${error.message}`);
      }
    } finally {
      setIsGenerating(false);
    }
  };


  const handleQuillChange = (content) => {
    setNewEmail({ ...newEmail, content: content });
  };

  const toggleCc = () => {
    setShowCc(!showCc);
  };

  const toggleBcc = () => {
    setShowBcc(!showBcc);
  };

  const handleSendEmail = async () => {
    setIsEmailSending(true);
    try {
      if (!newEmail.to || !newEmail.subject || !newEmail.content) {
        const missingFields = [];
        if (!newEmail.to) missingFields.push('To');
        if (!newEmail.subject) missingFields.push('Subject');
        if (!newEmail.content) missingFields.push('Content');
        throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
      }

      const attachments = await serializeEmailAttachments(emailAttachments);

      const emailPayload = {
        to: newEmail.to,
        subject: newEmail.subject,
        content: newEmail.content,
        cc: newEmail.cc || '',
        bcc: newEmail.bcc || '',
        attachments: attachments.length > 0 ? attachments : undefined,
      };

      console.log('Email Payload:', emailPayload);

      const response = await axiosInstance.post('/emails/send', emailPayload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setSnackbar({
        open: true,
        message: `Email sent for quotation ${quotation.id}`,
        severity: 'success',
      });

      setEmailAttachments([]);
      setIsEmailModalOpen(false);
    } catch (error) {
      console.error('Error sending email:', error);
      let errorMessage = 'Error sending email';

      if (error.response) {
        const { status, data } = error.response;
        if (status === 404 && data.detail === 'Email settings not found') {
          errorMessage = 'Email settings not configured. Please set up your email provider in settings.';
        } else if (status === 400 && data.detail.includes('Missing required fields')) {
          errorMessage = data.detail;
        } else if (status === 401) {
          errorMessage = 'Authentication failed. Please log in again.';
        } else {
          errorMessage = data.detail || error.message || 'Unknown error';
        }
      } else {
        errorMessage = error.message || 'Failed to connect to the server';
      }

      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error',
      });
    } finally {
      setIsEmailSending(false);
    }
  };


  // const handleDownloadPDF = (id) => {
  //   console.log(`Downloading PDF for quotation ${id}`);
  //   // Implement PDF download logic here
  //   setSnackbar({
  //     open: true,
  //     message: `PDF downloaded for quotation ${id}`,
  //     severity: 'success',
  //   });
  // };
  const handlePdfDownload = async () => {
    try {
      await downloadInvoice(quotation.id, true); // true indicates it should trigger download
    } catch (error) {
      console.error('Error downloading PDF:', error);
      setSnackbar({
        open: true,
        message: 'Failed to download PDF. Please try again.',
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    const fetchDealStage = async () => {
      if (!quotation?.deal_id || isDealLoading || dealDetails) return;

      try {
        setIsDealLoading(true);
        const dealResponse = await axiosInstance.get(`/deals/${quotation.deal_id}`);
        setDealDetails(dealResponse.data);
      } catch (error) {
        console.error('Error fetching deal details:', error);
      } finally {
        setIsDealLoading(false);
      }
    };

    fetchDealStage();
  }, [quotation?.deal_id, axiosInstance, isDealLoading, dealDetails]);

  const fetchOrderDetails = async () => {
    try {
      const orderResponse = await axiosInstance.get(`/quotations/${id}/order`);
      setOrder(orderResponse.data);
    } catch (err) {
      console.error('Error fetching order details:', err);
      // handleSnackbar('error', 'Failed to fetch order details. Please try again.');
    }
  };

  const handleFieldChange = (field, value) => {
    // Cap discount percentage and format monetary values
    let formattedValue = value;
    if (field === 'discount_percentage') {
      formattedValue = Math.min(parseFloat(value) || 0, 100);
    }
    if (['price', 'discounted_price', 'total_price', 'tax_rate'].includes(field)) {
      formattedValue = parseFloat(value || 0).toFixed(2);
    }

    // Handle custom fields explicitly
    setEditedFields((prev) => ({
      ...prev,
      [field]: formattedValue,
    }));

    setEditDialogFields((prev) => ({
      ...prev,
      [field]: formattedValue,
    }));
  };


  const refreshQuotationDetails = async () => {
    try {
      const [quotationResponse, itemsResponse, attachmentsResponse] = await Promise.all([
        axiosInstance.get(`/quotations/${id}`),
        axiosInstance.get(`/quotations/${id}/items/`),
        axiosInstance.get('/attachments/', {
          params: {
            parent_table: 'quotations',
            parent_id: id,
            sort_by: 'created_at',
            sort_order: 'desc'
          }
        })
      ]);

      // Update states with fresh data
      setQuotation(quotationResponse.data);
      setQuotationItems(itemsResponse.data);
      setAttachments(attachmentsResponse.data || []);
    } catch (error) {
      console.error('Error refreshing quotation details:', error);

      setSnackbar({
        open: true,
        message: 'Failed to refresh quotation details',
        severity: 'error',
      });
    }
  };

  // Create a helper function to check if PDF exists
  const checkPdfExists = (attachments) => {
    return attachments?.some(attachment =>
      attachment.file_name?.toLowerCase().includes('quotation_') &&
      attachment.file_type === 'application/pdf'
    );
  };

  // Replace the existing fetchAttachments useEffect
  useEffect(() => {
    const fetchAttachments = async () => {
      try {
        // Get current attachments
        const response = await axiosInstance.get('/attachments/', {
          params: {
            parent_table: 'quotations',
            parent_id: id,
          }
        });

        const currentAttachments = response.data || [];
        setAttachments(currentAttachments);

        // Only generate PDF if:
        // 1. Status is Sent/Accepted
        // 2. No PDF attachment exists
        // 3. This is the first load (quotation status has changed)
        const shouldGeneratePdf =
          (quotation?.status === 'Sent' || quotation?.status === 'Accepted') &&
          !checkPdfExists(currentAttachments) &&
          quotation?.status !== previousStatus.current;

        if (shouldGeneratePdf) {
          const pdfBlob = await downloadInvoice(quotation.id, false);
          if (pdfBlob) {
            const formData = new FormData();
            formData.append('file', pdfBlob, `quotation_${quotation.id}.pdf`);

            await axiosInstance.post('/attachments/', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

            // Refresh attachments list after adding new PDF
            const updatedResponse = await axiosInstance.get('/attachments/', {
              params: {
                parent_table: 'quotations',
                parent_id: id,
              }
            });
            setAttachments(updatedResponse.data || []);
          }
        }

        // Update previous status
        previousStatus.current = quotation?.status;

      } catch (error) {
        console.error('Error fetching/updating attachments:', error);
        setSnackbar({
          open: true,
          message: error.response?.data?.detail || 'Error managing attachments',
          severity: 'error',
          autoHideDuration: 5000
        });
      }
    };

    fetchAttachments();
  }, [id, quotation?.status]); // Dependencies remain the same

  // Add this at the top with other useRef declarations
  const previousStatus = useRef(null);

  const formatIndianNumber = (number) => {
    if (isNaN(number) || number === null || number === undefined) return "0.00";

    const [integerPart, decimalPart] = Number(number).toFixed(2).split(".");
    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);

    let formattedNumber = "";
    if (otherDigits) {
      formattedNumber = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThreeDigits;
    } else {
      formattedNumber = lastThreeDigits;
    }

    return `${formattedNumber}.${decimalPart}`; // Always include two decimal places
  };

  const handleSaveChanges = async () => {
    setIsSaving(true);
    try {
      const today = new Date().toISOString().split("T")[0];

      // First validate custom fields
      const isCustomFieldsValid = customFieldsRef.current?.validateAllFields() ?? true;

      if (Object.keys(formErrors).length > 0 || !isCustomFieldsValid) {
        setSnackbar({
          open: true,
          message: "Please fill the required fields before saving.",
          severity: 'error'
        });
        return;
      }

      if (editedFields.quote_date < today) {
        setSnackbar({
          open: true,
          message: "Cannot save quotation with a past expiration date.",
          severity: 'error'
        });
        setLoading(false);
        return;
      }

      if (editedFields.status === 'Draft' && quotation.status === 'Sent') {
        setSnackbar({
          open: true,
          message: 'Cannot change status from "Sent" to "Draft".',
          severity: 'error',
        });
        setLoading(false);
        return;
      }

      // Check if marking this quotation as Accepted
      // Backend will automatically reject other quotations for this deal
      if (editedFields.status === 'Accepted' && quotation.status !== 'Accepted') {
        const allQuotationsResponse = await axiosInstance.get('/quotations/');
        const otherQuotationsForDeal = allQuotationsResponse.data.filter(q =>
          q.deal_id === quotation.deal_id &&
          q.id !== quotation.id &&
          q.status !== 'Rejected'
        );

        if (otherQuotationsForDeal.length > 0) {
          // Show info message that other quotations will be rejected
          console.log(`Marking quotation ${quotation.id} as Accepted will automatically reject ${otherQuotationsForDeal.length} other quotation(s)`);
        }
      }

      const totalAmount = parseFloat(subtotal || 0) + Object.values(taxSummary).reduce((acc, curr) => acc + curr, 0);
      const quotationPayload = {
        ...editedFields,
        user_id: quotation.user_id,
        deal_id: quotation.deal_id,
        updated_at: new Date().toISOString(),
        subtotal: subtotal,
        total_amount: totalAmount,
      };

      const itemPayload = products
        .map(product => {
          const productData = productList.find(p => p.name === product.name);
          return {
            product_id: productData ? productData.id : null,
            product_name: product.name,
            price: parseFloat(product.price) || 0,
            tax: parseFloat(product.tax_rate) || 0,
            discount_percentage: parseFloat(product.discount_percentage) || 0,
            quantity: parseInt(product.quantity, 10) || 0,
            discounted_price: parseFloat(product.discounted_price) || 0,
            total_price: parseFloat(product.total_price) || 0,
          };
        })
        .filter(item => item.product_id);

      const previousItems = quotationItems.map(item => ({
        product_id: item.product_id,
        product_name: item.product_name,
        price: parseFloat(item.price) || 0,
        tax_rate: parseFloat(item.tax_rate) || 0,
        discount_percentage: parseFloat(item.discount_percentage) || 0,
        quantity: parseInt(item.quantity, 10) || 0,
        discounted_price: parseFloat(item.discounted_price) || 0,
        total_price: parseFloat(item.total_price) || 0,
      }));

      const hasChanges =
        itemPayload.length !== previousItems.length ||
        itemPayload.some((currentItem, index) => {
          const previousItem = previousItems[index];
          return (
            !previousItem ||
            currentItem.product_name !== previousItem.product_name ||
            currentItem.price !== previousItem.price ||
            currentItem.tax !== previousItem.tax ||
            currentItem.discount_percentage !== previousItem.discount_percentage ||
            currentItem.quantity !== previousItem.quantity ||
            currentItem.discounted_price !== previousItem.discounted_price ||
            currentItem.total_price !== previousItem.total_price
          );
        });

      if (hasChanges) {
        await axiosInstance.delete(`/quotations/items/${quotation.id}`);
        const [quotationResponse, itemsResponse] = await Promise.all([
          axiosInstance.put(`/quotations/${quotation.id}`, quotationPayload),
          axiosInstance.post(`/quotations/items/${quotation.id}`, itemPayload),
        ]);

        // Update local state with new data
        setQuotation(quotationResponse.data);
        setQuotationItems(itemPayload);

        // Handle status-specific actions
        // Note: Deal stage update and other quotations rejection is now handled automatically in the backend
        
        if (quotationResponse.data.status === 'Sent' || quotationResponse.data.status === 'Accepted') {
          await downloadInvoice(quotation.id);
          await handleStatusChange(quotationResponse.data.status);
        }

        // Refresh all data after save
        await Promise.all([
          // handleStatusChange(quotationResponse.data.status),
          fetchQuotationDetails(),
          // fetchOrderDetails(),
          fetchAttachments()
        ]);

        setSnackbar({
          open: true,
          message: 'Quotation updated successfully!',
          severity: 'success',
        });

        // --- Log quotation creation (update) ---
        await frontendLogger.logUpdate('Quotation', {
          id: quotation.id,
          updated_fields: Object.keys(editedFields),
          changes: editedFields,
          action: 'update',
          user: user.username,
          timestamp: new Date().toISOString(),
        });
      } else {
        // Handle case when only quotation data is changed
        const quotationResponse = await axiosInstance.put(`/quotations/${quotation.id}`, quotationPayload);
        setQuotation(quotationResponse.data);

        // Refresh all data after save
        await Promise.all([
          fetchQuotationDetails(),
          // fetchOrderDetails(),
          fetchAttachments()
        ]);

        setSnackbar({
          open: true,
          message: 'Quotation updated successfully!',
          severity: 'success',
        });
      }

      // Close edit dialog
      setIsEditCardOpen(false);
      // Reset edited fields
      setEditedFields({});

      setProducts([]);

    } catch (error) {
      console.error('Error updating quotation or items:', error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
      }
      setSnackbar({
        open: true,
        message: 'Failed to save changes. Please try again.',
        severity: 'error',
      });
    } finally {
      setIsSaving(false);
    }
  };



  const updateQuotationItems = async (quotationId, items) => {
    try {
      // Clear existing items first (optional, based on your API design)
      await axiosInstance.delete(`/quotations/${quotationId}/items/`);

      // Prepare the items for the API call
      const updatedItems = items.map(item => {
        const product = productList.find(p => p.name === item.name); // Assuming you have a product list to fetch IDs
        return {
          product_id: product ? product.id : null, // Ensure you have the product ID
          product_name: item.name,
          price: item.price,
          tax: item.tax_rate,
          discount_percentage: item.discount_percentage,
          quantity: item.quantity,
          discounted_price: item.discounted_price,
          total_price: item.total_price,
          deal_name: quotation.deal_name, // Include the deal_name from the quotation
        };
      }).filter(item => item.product_id); // Filter out items without a product ID

      console.log('Updated Items:', updatedItems); // Log the payload

      // Send the updated items to the API
      const response = await axiosInstance.post(`/quotations/${quotationId}/items/`, updatedItems);
      console.log('Update response:', response.data); // Log the response

      // Show success message
      setSnackbar({
        open: true,
        message: 'Product items updated successfully!',
        severity: 'success',
      });

    } catch (error) {
      console.error('Error updating quotation items:', error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
      }
      setSnackbar({
        open: true,
        message: 'Failed to update product items. Please try again.',
        severity: 'error',
      });
    }
  };

  const fetchInvoiceHtml = async (invoiceId) => {
    try {
      const response = await axiosInstance.get(`/quotations/${invoiceId}/html`);
      if (response.data) {
        return response.data; // Ensure this returns valid HTML
      } else {
        console.error('No HTML returned for invoice');
        return null;
      }
    } catch (error) {
      console.error('Error fetching invoice HTML:', error);
      return null;
    }
  };

  const displayInvoice = async () => {
    const invoiceHtml = await fetchInvoiceHtml(quotation.id); // Ensure this fetches the correct HTML
    if (invoiceHtml) {
      const pdf = new jsPDF();
      return new Promise((resolve) => {
        pdf.html(invoiceHtml, {
          callback: (doc) => {
            const pdfBlob = doc.output('blob'); // Get the PDF as a Blob
            resolve(pdfBlob); // Return the Blob
          },
          x: 10,
          y: 10,
        });
      });
    } else {
      console.error('Failed to fetch invoice HTML');
      return null; // Return null if HTML fetching fails
    }
  };


  // const handleFileUpload = async (pdfFile) => {
  //   try {
  //     const result = await uploadDocument(pdfFile);
  //     console.log('Upload successful!');
  //     console.log('File path:', result.path);
  //     console.log('File URL:', result.url);
  //   } catch (error) {
  //     console.error('Upload failed:', error);
  //   }
  // };


  const downloadInvoice = async (quotationId, shouldDownload = true) => {
    if (isDownloading) {
      console.warn("Download already in progress");
      return null;
    }

    setIsDownloading(true);
    setDownloadLoadingId(quotationId);

    try {
      const response = await axiosInstance.get(`/quotations/pdf/${quotationId}`, {
        responseType: 'blob',
        timeout: 30000
      });

      // Check if response is valid PDF blob
      if (response.data.type !== 'application/pdf') {
        throw new Error("Invalid response format - not a PDF");
      }

      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // If shouldDownload is true, trigger the download
      if (shouldDownload) {
        const blobUrl = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `Quotation_${quotationId}.pdf`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
        enqueueSnackbar("Quotation downloaded successfully", { variant: "success" });
      }

      return pdfBlob; // Return the blob for other uses

    } catch (error) {
      console.error("Error downloading quotation:", error);
      enqueueSnackbar(error.message || "Failed to download quotation", { variant: "error" });
      return null;
    } finally {
      setIsDownloading(false);
      setDownloadLoadingId(null);
    }
  };


  // Add at the top of the file
  const debugLog = (message, data = null) => {
    const timestamp = new Date().toISOString();
    console.log(`[${timestamp}] ${message}`, data ? data : '');
  };

  const uploadQuotation = async (
    file
  ) => {
    const tenant = window.location.hostname.split('.')[0];
    const fileName = `quotation_${quotation.id}.pdf`;
    try {
      if (!file) {
        throw new Error('No file provided');
      }
      const uploadResult = await uploadPrivateObject({
        axiosInstance,
        file,
        env: process.env.REACT_APP_STORAGE_ENV,
        featurePath: 'quotations',
        scope: 'user',
        includeDatePartition: true
      });

      return {
        path: uploadResult.path,
        bucket: uploadResult.bucket,
        url: uploadResult.url,
        file: {
          name: fileName,
          size: file.size,
          type: file.type
        }
      };

    } catch (error) {
      console.error('Document upload error:', error);
      throw error;
    }
  };

  const handleStatusChange = async (newStatus) => {
    console.log('[DEBUG] Started handleStatusChange', {
      newStatus,
      quotationId: quotation.id
    });

    try {
      // Update quotation status
      console.log('[DEBUG] Sending status update request...');
      const statusUpdateResponse = await axiosInstance.put(`/quotations/status/${quotation.id}`, {
        status: newStatus
      });

      console.log('[DEBUG] Status update response received', {
        status: statusUpdateResponse.status,
        data: statusUpdateResponse.data
      });

      // If status is 'Sent' or 'Accepted', upload the PDF
      if (newStatus === 'Sent' || newStatus === 'Accepted') {
        console.log('[DEBUG] Preparing PDF attachment upload', { quotationId: quotation.id });

        try {
          // Get the PDF blob
          console.log('[DEBUG] Fetching PDF content...');
          const pdfResponse = await axiosInstance.get(`/quotations/pdf/${quotation.id}`, {
            responseType: 'blob',
            timeout: 30000
          });

          console.log('[DEBUG] PDF Response received', {
            type: pdfResponse.data?.type,
            size: pdfResponse.data?.size,
            headers: pdfResponse.headers
          });

          // Check if response is valid PDF blob
          if (!pdfResponse.data || pdfResponse.data.size === 0) {
            throw new Error("Empty PDF data received");
          }

          if (pdfResponse.data.type !== 'application/pdf') {
            console.warn('[WARN] Response content type is not PDF:', pdfResponse.data.type);
          }

          const pdfBlob = pdfResponse.data;
          const fileSize = pdfBlob.size;

          console.log('[DEBUG] PDF Blob details', {
            type: pdfBlob.type,
            size: fileSize,
            isEmpty: fileSize === 0
          });

          // Only proceed if we have non-empty data
          if (fileSize > 0) {
            // Let's try to preview a small portion of the PDF data to confirm it's valid
            const previewPromise = new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                // Log first 100 chars of the base64 data to check if it looks valid
                const preview = reader.result.substring(0, 100);
                console.log('[DEBUG] PDF Data Preview:', preview);
                resolve(true);
              };
              reader.readAsDataURL(pdfBlob);
            });

            await previewPromise;

            const response = await uploadQuotation(pdfBlob);
            console.log('[DEBUG] PDF upload response:', response);
            const attachmentPayload = {
              file_name: response.file.name,
              file_type: 'application/pdf',
              content_type: 'application/pdf',
              bucket_name: response.bucket,
              description: `Quotation PDF - ${quotation.quote_name}`,
              parent_table: 'quotations',
              parent_id: quotation.id,
              is_active: true,
              is_private: false,
              file_size: response.file.size,
              file_url: response.url, // Link to where the PDF can be accessed
              storage_path: response.path, // Path in Supabase storage
            };

            const attachmentResponse = await axiosInstance.post('/attachments/', attachmentPayload);
          } else {
            throw new Error('PDF data is empty');
          }

        } catch (error) {
          console.error('[ERROR] Failed to process or upload PDF', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
          });
          throw error;
        }
      }

      // Refresh quotation details
      console.log('[DEBUG] Refreshing quotation details...');
      await fetchQuotationDetails();

      // Reset UI states
      console.log('[DEBUG] Closing edit card and showing success message...');
      setIsEditCardOpen(false);
      setSnackbar({
        open: true,
        message: `Quotation status updated to ${newStatus}`,
        severity: 'success',
      });

      // --- Log quotation creation (status change) ---
      await frontendLogger.logUpdate('Quotation', {
        id: quotation.id,
        action: 'status_change',
        old_status: quotation.status,
        new_status: newStatus,
        user: user.username,
        timestamp: new Date().toISOString(),
      });

    } catch (error) {
      console.error('[ERROR] Error in handleStatusChange', {
        message: error.message,
        stack: error.stack,
        response: error.response?.data
      });

      setSnackbar({
        open: true,
        message: `Error updating status: ${error.message}`,
        severity: 'error',
      });
    }
  };



  const renderEditableField = (key, label, validationRules = {}) => {
    const value = editedFields[key] !== undefined
      ? editedFields[key]
      : quotation[key];

    // Optional validation
    const hasError = validationRules.validate
      ? !validationRules.validate(value)
      : false;

    return (
      <TextField
        label={label}
        value={value}
        onChange={(e) => {
          const newValue = e.target.value;

          // Optional validation before setting
          if (!validationRules.validate || validationRules.validate(newValue)) {
            handleFieldChange(key, newValue);
          }
        }}
        error={hasError}
        helperText={hasError ? validationRules.errorMessage : ''}
        fullWidth
        variant="outlined"
        size="small"
        type={['price', 'discounted_price', 'total_price', 'tax_rate'].includes(key) ? 'text' : 'text'}
        inputProps={{
          step: "0.01", // Allow decimal input
          min: "0", // Minimum value
          max: key === 'discount_percentage' ? "100" : undefined // Cap for discount percentage
        }}
      />
    );
  };


  const handleSnackbar = (severity, message) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };



  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'Sent': return '#3498db';
      case 'Draft': return '#f39c12';
      case 'Accepted': return '#2ecc71';
      case 'Rejected': return '#e74c3c';
      default: return '#95a5a6';
    }
  };

  const handleDelete = async () => {
    setIsDeleting(true);
    handleCloseDeleteModal();
    try {
      // First, delete the items associated with the quotation
      await axiosInstance.delete(`/quotations/items/${id}`);

      // Then, delete the quotation
      const response = await axiosInstance.delete(`/quotations/${id}`);

      // Handle successful deletion
      console.log(response.data.detail);  // "Quotation and associated items deleted successfully"
      navigate(`/deals/${quotation.deal_id}`); // Redirect to the deal page

      // --- Log quotation deletion ---
      await frontendLogger.logDelete('Quotation', {
        id: id,
        deleted_by: user.id,
        user: user.username,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('Error deleting quotation:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting quotation. Please try again.',
        severity: 'error',
      });
    } finally {
      setIsDeleting(false);
    }
  };



  const handleClonequotation = async () => {
    try {
      setIsCloning(true);

      // Step 1: Check if the quotation is in Draft status
      if (quotation.status === 'Draft') {
        setSnackbar({
          open: true,
          message: 'Please change the quotation status before cloning.',
          severity: 'warning',
        });
        return;
      }

      // Step 2: Clone the quotation (omit the 'id' field)
      const clonedQuotation = { ...quotation, status: 'Draft' };
      delete clonedQuotation.id;
      console.log('Cloned quotation:', clonedQuotation); // Debugging log

      // Step 3: Post the cloned quotation to the API
      const quotationResponse = await axiosInstance.post('/quotations/', clonedQuotation);
      console.log('Quotation response:', quotationResponse); // Debugging log

      // Step 4: Get the new quotation ID from the response
      const newQuotationId = quotationResponse.data.id;
      console.log('New quotation ID:', newQuotationId); // Debugging log

      // Step 5: Fetch the items from the original quotation
      const itemsResponse = await axiosInstance.get(`/quotations/${quotation.id}/items/`);
      console.log('Original items fetched from API:', itemsResponse.data); // Debugging log

      if (itemsResponse.data && itemsResponse.data.length > 0) {
        // Step 6: Clone the associated items (if any)
        const clonedItems = itemsResponse.data.map(item => {
          const newItem = { ...item };
          delete newItem.id; // Remove the old item ID to ensure the new item is created
          newItem.quotation_id = newQuotationId; // Assign the new quotation ID to each item
          return newItem;
        });

        console.log('Cloned items:', clonedItems); // Debugging log

        // Step 7: Send all cloned items as a list in one POST request
        const response = await axiosInstance.post(`/quotations/${newQuotationId}/items/`, clonedItems);
        console.log('Cloned items posted response:', response); // Debugging log
      } else {
        console.log('No items to clone'); // Debugging log
      }

      // Step 8: Show success message
      setSnackbar({
        open: true,
        message: 'Quotation cloned successfully!',
        severity: 'success',
      });

      // Step 9: Navigate to the new quotation's detail page
      setTimeout(() => {
        navigate(`/quote/${newQuotationId}`);
      }, 1000);
    } catch (error) {
      console.error('Error cloning quotation:', error);

      // Step 10: Show error message
      setSnackbar({
        open: true,
        message: 'Error cloning quotation. Please try again.',
        severity: 'error',
      });
    } finally {
      // Reset cloning state
      setIsCloning(false);
    }
  };


  const handleDeleteProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
  };



  const fetchAttachments = async () => {
    const parentTable = 'quotations';
    const parentId = id;
    try {
      const response = await axiosInstance.get('/attachments/', {
        params: {
          parent_table: parentTable,
          parent_id: parentId
          // skip: 0,
          // limit: 100,
          // sort_by: 'created_at',
          // sort_order: 'desc'
        }
      });

      setAttachments(response.data || []);

    } catch (error) {
      console.error('Error fetching attachments:', error);
      const errorMessage = error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        'Error fetching attachments';

      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error',
        autoHideDuration: 5000
      });
    } finally {
      // If you have a loading state
      // setLoading(false);
    }
  };

  const handleDeleteAttachment = async (attachmentId) => {
    try {
      await axiosInstance.delete(`/attachments/${attachmentId}`);
      setAttachments(attachments.filter((attachment) => attachment.id !== attachmentId));
      setSnackbar({
        open: true,
        message: 'Attachment deleted successfully!',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error deleting attachment:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting attachment',
        severity: 'error',
      });
    }
  };

  const handleDownloadAttachment = async (attachment) => {
    try {
      if (!attachment.bucket_name || !attachment.storage_path) {
        throw new Error('Attachment storage metadata is invalid for strict R2 download');
      }
      await downloadPrivateObject({
        axiosInstance,
        attachmentId: attachment.id,
        fileName: attachment.file_name
      });
    } catch (error) {
      console.error('Error downloading attachment:', error);
      setSnackbar({
        open: true,
        message: 'Error downloading attachment',
        severity: 'error',
      });
    }
  };

  const handleUploadSuccess = async (uploadData) => {
    console.log('Upload successful:', uploadData);

    if (!uploadData || !uploadData.file) {
      console.error('Invalid uploadData:', uploadData);
      return;
    }

    console.log('Preparing uploadDataPayload...');
    const uploadDataPayload = {
      file_name: uploadData.file.name,
      file_type: 'application/pdf',
      content_type: 'application/pdf',
      file_size: uploadData.file.size,
      bucket_name: uploadData.bucket,
      storage_path: uploadData.path,
      description: uploadData.description || '', // Optional, use default if no description is provided
      parent_table: 'quotations',  // Assuming the parent table is 'quotations', modify as needed
      parent_id: id,  // Assuming the parent ID is the same as lead ID
      is_active: true,
      is_private: true,
      file_url: uploadData.url || null,
      signed_url_expiry: uploadData.signedUrlExpiry || null,
    };

    console.log('Payload ready:', uploadDataPayload);

    setIsAttachmentModalOpen(false);
    try {
      console.log('Sending request to /attachments/ endpoint...');
      const response = await axiosInstance.post(`/attachments/`, uploadDataPayload);

      console.log('Upload response status:', response.status);
      console.log('Upload response data:', response.data);

      setSnackbar({
        open: true,
        message: 'File uploaded successfully!',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error uploading file:', error);

      if (error.response) {
        console.error('Error response status:', error.response.status);
        console.error('Error response headers:', error.response.headers);
        console.error('Error response data:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up request:', error.message);
      }

      setSnackbar({
        open: true,
        message: 'Error uploading file',
        severity: 'error',
      });
    } finally {
      console.log('Fetching attachments...');
      fetchAttachments();
    }
  };

  // Echo/Feed functionality functions
  const fetchFeedItems = async () => {
    try {
      setIsFeedLoading(true);
      console.log('Fetching feed items for:', { entityType: 'quotations', entityId: id });
      const response = await axiosInstance.get(`/feed-items/entity/quotations/${id}`);
      console.log('Fetched feed items:', response.data);
      console.log('Feed items count:', response.data?.length || 0);
      setFeedItems(response.data || []);
    } catch (error) {
      console.error('Error fetching feed items:', error);
      console.error('Error response:', error.response?.data);
      setFeedItems([]);
      // Don't show error snackbar for feed items as it's not critical
    } finally {
      setIsFeedLoading(false);
    }
  };

  // Handler for when a new message is posted
  const handleEchoSubmit = async (feedItem) => {
    // Add the new feed item to the beginning of the list
    setFeedItems(prevItems => [feedItem, ...prevItems]);
    
    // Close the modal
    handleCloseEchoModal();
    
    // Show success message
    setSnackbar({
      open: true,
      message: 'Message posted successfully!',
      severity: 'success',
    });
    
    // Refresh the feed items to ensure we have the latest data
    await fetchFeedItems();
  };

  const handleEditFeedItem = async (editData) => {
    try {
      setIsEditingFeed(true);
      
      // Extract the feed item ID from the edit data
      const feedItemId = editData.feed_item_id;
      
      if (!feedItemId) {
        throw new Error('No feed item ID found in edit data');
      }
      
      console.log('=== EDIT FEED ITEM DEBUG ===');
      console.log('Feed Item ID:', feedItemId);
      console.log('Edit Data received:', editData);
      console.log('Object Type:', editData.object_type);
      console.log('Object ID:', editData.object_id);
      console.log('Body content:', editData.body);
      console.log('Mentions:', editData.mentions);
      
      // Make the PUT request to the correct endpoint with the feed item ID
      const response = await axiosInstance.put(`/feed-items/${feedItemId}`, {
        feeditem: {
          object_type: editData.object_type,
          object_id: editData.object_id,
          body: editData.body
          // Don't include mentions - backend will parse them from body automatically
        }
      });
      
      if (response.status === 200) {
        // Refresh the entire feed to get updated data and proper sorting
        await fetchFeedItems();
        
        setSnackbar({
          open: true,
          message: 'Message updated successfully!',
          severity: 'success',
        });
        
        // The EchoComposer will handle clearing the edit state via onSuccess callback
        // so we don't need to do it here
      }
    } catch (error) {
      console.error('Error updating feed item:', error);
      // setSnackbar({
      //   open: true,
      //   message: 'Error updating message',
      //   severity: 'error',
      // });
    } finally {
      setIsEditingFeed(false);
    }
  };

  const handleDeleteFeedItem = async (feedItemId) => {
    try {
      const response = await axiosInstance.delete(`/feed-items/${feedItemId}`);
      
      if (response.status === 200) {
        // Update the feed items state by removing the deleted item
        setFeedItems(prevItems => prevItems.filter(item => item.id !== feedItemId));
        
        setSnackbar({
          open: true,
          message: 'Message deleted successfully!',
          severity: 'success',
        });
      }
    } catch (error) {
      console.error('Error deleting feed item:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting message',
        severity: 'error',
      });
    }
  };

  const handleDeleteConfirm = (feedItem) => {
    setItemToDelete(feedItem);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setItemToDelete(null);
  };

  const handleDeleteConfirmOk = async () => {
    if (itemToDelete) {
      await handleDeleteFeedItem(itemToDelete.id);
      setDeleteConfirmOpen(false);
      setItemToDelete(null);
    }
  };

  const startEditFeedItem = (feedItem) => {
    setEditingFeedItem(feedItem.id);
    setEditFeedContent(feedItem.feeditem.body);
  };

  const cancelEditFeedItem = () => {
    setEditingFeedItem(null);
    setEditFeedContent('');
  };

  const handleOpenEchoModal = () => {
    setIsEchoModalOpen(true);
  };

  const handleCloseEchoModal = () => {
    setIsEchoModalOpen(false);
  };

  // Helper functions for fetching entity names
  const fetchEntityName = async (entityType, entityId) => {
    try {
      const cacheKey = `${entityType.toLowerCase()}_${entityId}`;
      if (nameCache[cacheKey]) {
        return nameCache[cacheKey];
      }

      let response;
      switch (entityType.toLowerCase()) {
        case 'leads':
          response = await axiosInstance.get(`/leads/${entityId}`);
          break;
        case 'deals':
          response = await axiosInstance.get(`/deals/${entityId}`);
          break;
        case 'accounts':
          response = await axiosInstance.get(`/accounts/${entityId}`);
          break;
        case 'contacts':
          response = await axiosInstance.get(`/contacts/${entityId}`);
          break;
        case 'orders':
          response = await axiosInstance.get(`/orders/${entityId}`);
          break;
        case 'invoices':
          response = await axiosInstance.get(`/invoices/${entityId}`);
          break;
        case 'quotations':
          response = await axiosInstance.get(`/quotations/${entityId}`);
          break;
        case 'products':
          response = await axiosInstance.get(`/products/${entityId}`);
          break;
        default:
          return entityId;
      }

      const name = response.data?.name || response.data?.title || response.data?.quote_name || entityId;
      setNameCache(prev => ({ ...prev, [cacheKey]: name }));
      return name;
    } catch (error) {
      console.error(`Error fetching ${entityType} name:`, error);
      return entityId;
    }
  };

  const fetchUserName = async (userId) => {
    try {
      const cacheKey = `user_${userId}`;
      if (nameCache[cacheKey]) {
        return nameCache[cacheKey];
      }

      const response = await axiosInstance.get(`/users/${userId}`);
      const name = response.data?.full_name || response.data?.username || userId;
      setNameCache(prev => ({ ...prev, [cacheKey]: name }));
      return name;
    } catch (error) {
      console.error('Error fetching user name:', error);
      return userId;
    }
  };

  // Component for rendering mentions with immediate name display
  const MentionDisplay = ({ mention, fullMatch, entityTypeOrUser, entityId, mentions, navigate }) => {
    // Calculate display name immediately without async operations
    let displayName = '';
    
    if (entityId) {
      // For entity mentions, we'll need to fetch the name
      // But for now, let's show the entity type and ID
      displayName = `${entityTypeOrUser}:${entityId}`;
    } else {
      // For user mentions, use entity_name immediately if available
      if (mention && mention.entity_name) {
        displayName = mention.entity_name;
      } else {
        // Fallback to username
        displayName = entityTypeOrUser;
      }
    }

    return (
      <Box
        component="span"
        sx={{
          color: entityId ? 'info.main' : 'primary.main',
          fontWeight: 'bold',
          backgroundColor: entityId ? 'rgba(33, 150, 243, 0.08)' : 'rgba(103, 58, 183, 0.08)',
          px: 0.5,
          py: 0.25,
          borderRadius: 0.5,
          mx: 0.25,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: entityId ? 'rgba(33, 150, 243, 0.15)' : 'rgba(103, 58, 183, 0.15)',
          }
        }}
        onClick={() => {
          if (entityId) {
            // Navigate to the mentioned entity
            navigate(`/${entityTypeOrUser.toLowerCase()}s/${entityId}`);
          } else {
            // Handle user mention - navigate to user profile
            if (mention && mention.entity_id) {
              navigate(`/users/${mention.entity_id}/profile`);
            }
          }
        }}
      >
        {displayName}
      </Box>
    );
  };

  // Helper function to extract name parts from created_by_name
  const extractNameParts = (createdByUser, createdByName) => {
    let nameParts = {
      firstName: 'U',
      middleName: '',
      lastName: '',
      avatarUrl: null
    };

    if (createdByUser?.first_name && createdByUser?.last_name) {
      nameParts = {
        firstName: createdByUser.first_name,
        middleName: createdByUser.middle_name || '',
        lastName: createdByUser.last_name,
        avatarUrl: createdByUser.avatar || null
      };
    } else if (createdByName) {
      const namePartsArray = createdByName.split(' ').filter(part => part.trim());
      if (namePartsArray.length === 1) {
        nameParts = {
          firstName: namePartsArray[0],
          middleName: '',
          lastName: '',
          avatarUrl: null
        };
      } else if (namePartsArray.length >= 2) {
        nameParts = {
          firstName: namePartsArray[0],
          middleName: namePartsArray.slice(1, -1).join(' '),
          lastName: namePartsArray[namePartsArray.length - 1],
          avatarUrl: null
        };
      }
    }
    
    return nameParts;
  };

  // Enhanced feed content parser that uses async name fetching
  const parseFeedContent = (feedItem) => {
    if (!feedItem?.feeditem?.body) return '';
    
    const body = feedItem.feeditem.body;
    const mentions = feedItem.feeditem.mentions || [];
    
    console.log('Parsing feed content:', { body, mentions });
    
    // Parse mentions in the format @username (for users) or @EntityType:entityId (for entities)
    const parts = [];
    const mentionRegex = /@([A-Za-z0-9_.@]+)(?::([A-Za-z0-9_]+))?/g;
    let lastIndex = 0;
    let match;
    
    // Create a map of usernames to mention data for better matching
    const userMentionsMap = {};
    mentions.forEach(mention => {
      if (mention.type === 'user' && mention.entity_name) {
        // Try to match by username pattern in the body
        const usernamePattern = new RegExp(`@${mention.entity_name.replace(/\s+/g, '[._]')}`, 'i');
        if (usernamePattern.test(body)) {
          userMentionsMap[mention.entity_name] = mention;
        }
      }
    });
    
    while ((match = mentionRegex.exec(body)) !== null) {
      // Add text before mention
      if (match.index > lastIndex) {
        parts.push(
          <span key={`text-${lastIndex}`}>
            {body.substring(lastIndex, match.index)}
          </span>
        );
      }
      
      // Add mention as highlighted text with async name fetching
      const [fullMatch, firstPart, secondPart] = match;
      
      // Determine if this is a user mention or entity mention
      let entityTypeOrUser, entityId;
      
      if (secondPart) {
        // Format: @EntityType:entityId
        entityTypeOrUser = firstPart;
        entityId = secondPart;
      } else {
        // Format: @username (user mention)
        entityTypeOrUser = firstPart;
        entityId = null;
      }
      
      // Find the corresponding mention data
      let mentionData;
      if (entityId) {
        // For entity mentions: @EntityType:entityId
        mentionData = mentions.find(m => m.type === 'record' && m.entity_type === entityTypeOrUser && m.entity_id === entityId);
      } else {
        // For user mentions: @username - try multiple matching strategies
        // First, try exact match with entity_name
        mentionData = mentions.find(m => m.type === 'user' && m.entity_name === entityTypeOrUser);
        
        // If not found, try matching by username pattern
        if (!mentionData) {
          const userMention = mentions.find(m => {
            if (m.type === 'user' && m.entity_name) {
              // Check if the username in text matches the entity_name (with possible dots/underscores)
              const normalizedEntityName = m.entity_name.replace(/\s+/g, '[._]');
              const usernamePattern = new RegExp(`^${normalizedEntityName}$`, 'i');
              return usernamePattern.test(entityTypeOrUser);
            }
            return false;
          });
          if (userMention) {
            mentionData = userMention;
          }
        }
        
        // If still not found, try to find by position in the mentions array
        if (!mentionData) {
          const userMentions = mentions.filter(m => m.type === 'user');
          // Count how many user mentions we've seen so far in the text
          const textBeforeCursor = body.substring(0, match.index);
          const userMentionsBefore = (textBeforeCursor.match(/@[A-Za-z0-9_.@]+/g) || []).length;
          if (userMentionsBefore < userMentions.length) {
            mentionData = userMentions[userMentionsBefore];
          }
        }
      }
      
      parts.push(
        <MentionDisplay
          key={`mention-${match.index}`}
          mention={mentionData}
          fullMatch={fullMatch}
          entityTypeOrUser={entityTypeOrUser}
          entityId={entityId}
          mentions={mentions}
          navigate={navigate}
        />
      );
      
      lastIndex = match.index + fullMatch.length;
    }
    
    // Add remaining text
    if (lastIndex < body.length) {
      parts.push(
        <span key={`text-end`}>
          {body.substring(lastIndex)}
        </span>
      );
    }
    
    return parts;
  };


  const [productList, setProductList] = useState([]);
  const [suggestions, setSuggestions] = useState({
    locations: [],
    categories: [],
    brands: [],
    manufacturers: [],
    names: [],
  });

  useEffect(() => {
    const extractUniqueSuggestions = async () => {
      try {
        const [productsResponse, inventoryResponse] = await Promise.all([
          axiosInstance.get("/products/"),
          axiosInstance.get("/inventory/details/"),
        ]);

        const extractUnique = (arr, field) =>
          [...new Set(arr.map((item) => item[field]))].filter(
            (value) => value && value.trim() !== ""
          );

        setSuggestions({
          locations: extractUnique(inventoryResponse.data, "location"),
          categories: extractUnique(productsResponse.data, "category"),
          brands: extractUnique(productsResponse.data, "brand"),
          manufacturers: extractUnique(productsResponse.data, "manufacturer"),
          names: extractUnique(productsResponse.data, "name"),
        });

        setProductList(productsResponse.data);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    };

    extractUniqueSuggestions();
  }, []);
  const calculateTaxSummary = (items) => {
    let taxSummary = {};

    items.forEach((item) => {
      const taxRate = item.tax_rate; // Assuming tax_rate is the field for tax percentage
      const price = parseFloat(item.price) || 0;
      const quantity = parseFloat(item.quantity) || 0;
      const discountPercentage = parseFloat(item.discount_percentage) || 0;
      const discountedPrice = price - (price * (discountPercentage / 100));
      // Tax on discounted net (after discount).
      const taxAmount = (discountedPrice * quantity * ((taxRate || 0) / 100)).toFixed(2);

      taxSummary[taxRate] = (taxSummary[taxRate] || 0) + parseFloat(taxAmount);
    });

    return taxSummary;
  };
  const taxSummary = calculateTaxSummary(products); // Ensure 'products' is the state holding the items

  const calculateDiscountedPrice = (item) => {
    const price = parseFloat(item.price) || 0;
    const discountPercentage = parseFloat(item.discount_percentage) || 0;
    return price - (price * (discountPercentage / 100));
  };

  const calculateTotalPrice = (item) => {
    const discountedPrice = parseFloat(item.discounted_price) || 0;
    const quantity = parseFloat(item.quantity) || 0;
    return discountedPrice * quantity;
  };

  // const generateOrderNumber = async () => {
  //   try {
  //     // Fetch the latest order to generate a unique order number
  //     const response = await axiosInstance.get('/orders/latest-number');
  //     const latestOrderNumber = response.data.latest_order_number;

  //     // Generate new order number (increment the last number)
  //     const newOrderNumber = latestOrderNumber
  //       ? `ORD-${parseInt(latestOrderNumber.split('-')[1]) + 1}`
  //       : 'ORD-1';

  //     setGeneratedOrderNumber(newOrderNumber);
  //     return newOrderNumber;
  //   } catch (error) {
  //     console.error('Error generating order number:', error);

  //     // Fallback method if API fails
  //     const timestamp = new Date().getTime();
  //     const fallbackOrderNumber = `ORD-${timestamp}`;
  //     setGeneratedOrderNumber(fallbackOrderNumber);
  //     return fallbackOrderNumber;
  //   }
  // };d


  const handleCreateOrder = async () => {
    try {
      // Prepare order payload (order_number is assigned by the backend)
      const orderPayload = {
        order_date: new Date().toISOString(),
        contact_id: dealDetails.contact_id,
        deal_id: quotation.deal_id,
        quotation_id: quotation.id,
        status: 'Draft',
        total_amount: parseFloat(quotation.total_amount || 0),
        shipping_method: quotation.shipping_method,
        notes: `Created from Quotation ${quotation.id} for Deal ${quotation.deal_id}`,
        delivery_date: quotation.delivery_date,
        // payment_methods: quotation.payment_methods,
        // shipping_address: quotation.shipping_address
      };

      // Log the order payload
      console.log("Order Payload:", orderPayload);

      // Step 1: Create the order
      const orderResponse = await axiosInstance.post('/orders/', orderPayload);

      // Get the created order ID
      const orderId = orderResponse.data.id;

      // Prepare order items payload
      const orderItemsPayload = quotationItems.map(item => ({
        product_id: item.product_id,
        product_name: item.product_name,
        quantity: item.quantity,
        unit_price: parseFloat(item.price),
        total_price: parseFloat(item.total_price),
        discount_percentage: item.discount_percentage,
        order_id: orderId // Associate the item with the created order
      }));

      // Log the order items payload
      console.log("Order Items Payload:", orderItemsPayload);

      // Step 2: Create the order items using the created order ID
      await Promise.all(
        orderItemsPayload.map(item =>
          axiosInstance.post('/orders/items/', item)
        )
      );

      // Show success message
      setSnackbar({
        open: true,
        message: `Order ${orderResponse.data.order_number || orderId} and its items created successfully!`,
        severity: 'success'
      });

      // Close the modal
      setIsCreateOrderModalOpen(false);

      // Navigate to the new order's detail page
      navigate(`/orders/${orderId}`);
    } catch (error) {
      console.error('Error creating order:', error);

      // Detailed error handling
      let errorMessage = 'Failed to create order. Please try again.';

      if (error.response) {
        if (error.response.data) {
          if (typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          } else if (error.response.data.detail) {
            if (Array.isArray(error.response.data.detail)) {
              errorMessage = error.response.data.detail
                .map(err => `${err.loc[1] || 'Field'}: ${err.msg}`)
                .join('; ');
            } else {
              errorMessage = error.response.data.detail;
            }
          }
        }
      }

      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    }
  };

  const renderDetailCard = (title, data, renderContent = null) => (
    <MDBox
      my={3}
      p={3}
      borderRadius="lg"
      sx={{
        backgroundColor: 'white',
        boxShadow: 3,
      }}
    >
      {/* Header */}
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MDTypography variant="h6" fontWeight="medium" color="dark">
          {title}
        </MDTypography>
      </MDBox>

      {/* Render array-based fields or object-based details */}
      <Grid container spacing={3}>
        {/* Handle array of fields with label and field */}
        {Array.isArray(data) && data.length > 0 ? (
          data.map((item) => (
            <Grid item xs={12} sm={6} key={item.label || item.field}>
              <MDBox display="flex" alignItems="center">
                <MDTypography variant="button" fontWeight="bold" color="text">
                  {item.label}:
                </MDTypography>
                <MDTypography fontSize="0.865rem" color="text" ml={1}>
                  {item.value || (item.field && order?.[item.field]) || ''}
                </MDTypography>
              </MDBox>
            </Grid>
          ))
        ) : (
          // Handle object-based details (key-value pairs)
          !Array.isArray(data) &&
          Object.entries(data).map(([key, value]) => (
            <Grid item xs={12} sm={6} key={key}>
              <MDBox display="flex" alignItems="center">
                <MDTypography variant="button" fontWeight="bold" color="text">
                  {key}:
                </MDTypography>
                <MDTypography fontSize="0.865rem" color="text" ml={1}>
                  {value}
                </MDTypography>
              </MDBox>
            </Grid>
          ))
        )}
      </Grid>
      {/* Render custom content if provided */}
      {renderContent && (
        <MDBox mt={3}>
          {typeof renderContent === 'function' ? renderContent() : renderContent}
        </MDBox>
      )}
    </MDBox>
  );


  // Add these handler functions
  const handleFieldUpdate = (field, value) => {
    console.log(`Updating field ${field} with value:`, value);
    setEditedFields(prev => {
      const newFields = { ...prev, [field]: value };
      console.log('Updated editedFields:', newFields);
      return newFields;
    });
  };

  const handleFieldError = (field, error) => {
    console.log(`Field error update: ${field}, Error: ${error}`);
    if (error) {
      setFormErrors(prev => ({
        ...prev,
        [field]: error
      }));
    } else {
      setFormErrors(prev => {
        const { [field]: _, ...rest } = prev;
        return rest;
      });
    }
  };

  useEffect(() => {
    if (quotation && quotation.custom_fields) {
      // Merge custom fields into edited fields when quotation data changes
      setEditedFields(prev => ({
        ...prev,
        ...quotation,
        ...quotation.custom_fields
      }));
    }
  }, [quotation]);

  const renderCustomFields = () => {
    if (!customFields || customFields.length === 0) {
      return null;
    }
    return (
      <CustomFieldsSection
        ref={customFieldsRef}
        objectType="quotations"
        objectData={editedFields}
        isEditing={true}
        onFieldUpdate={handleFieldUpdate}
        onError={handleFieldError}
        formErrors={formErrors}
      />
    );
  };

  // Update the handleSave function to include custom fields
  const handleSave = async () => {
    if (Object.keys(formErrors).length > 0) {
      setSnackbar({
        open: true,
        message: 'Please fix all errors before saving.',
        severity: 'error',
      });
      return;
    }

    try {
      // Prepare the payload with custom fields
      const payload = {
        ...quotation,
        ...updatedFields,
        custom_fields: {}, // Add custom_fields object
        updated_at: new Date().toISOString(),
      };

      // Move custom fields to custom_fields object
      Object.keys(payload).forEach(key => {
        if (key.startsWith('cf_')) {
          payload.custom_fields[key] = payload[key];
          delete payload[key];
        }
      });

      const response = await axiosInstance.put(`/quotations/${id}`, payload);

      // Force a complete refresh of the quotation data
      const refreshResponse = await axiosInstance.get(`/quotations/${id}`);
      const quotationData = refreshResponse.data;

      // Merge custom fields into main data
      if (quotationData.custom_fields) {
        Object.entries(quotationData.custom_fields).forEach(([key, value]) => {
          quotationData[key] = value;
        });
      }

      setQuotation(quotationData);
      setUpdatedFields({});
      setFormErrors({});
      setSnackbar({
        open: true,
        message: 'Quotation updated successfully!',
        severity: 'success',
      });

      // --- Log quotation creation (update) ---
      await frontendLogger.logUpdate('Quotation', {
        id: quotation.id,
        updated_fields: Object.keys(updatedFields),
        changes: updatedFields,
        action: 'update',
        user: user.username,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('Error updating quotation:', error);
      setSnackbar({
        open: true,
        message: 'Error updating quotation. Please try again.',
        severity: 'error',
      });
    }
  };

  if (isLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <DataLoadingSpinner
          entityType="Quotation"
          title="Loading Quotation Data"
          message="Please wait while we fetch the quotation information..."
        />
        
      </DashboardLayout>
    );
  }

  if (!quotation) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" height="80vh">
          <MDTypography variant="h4">Quotation not found</MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }


  const fieldsConfig = [
    // Editable fields
    { key: 'quote_name', label: 'Quote Name', validation: { minLength: 1, maxLength: 100 } },
    {
      key: 'account_name',
      label: 'Account',
      type: 'link',
      options: editDialogAccountOptions,
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'Draft', label: 'Draft', color: '#FFC107', disabled: quotation.status === 'Sent' },
        { value: 'Sent', label: 'Sent', color: '#2196F3' },
        { value: 'Accepted', label: 'Accepted', color: '#4CAF50' },
        { value: 'Rejected', label: 'Rejected', color: '#F44336' },
      ],
    },
    {
      key: 'subtotal',
      label: 'Subtotal',
      type: 'currency',
      validation: { min: 0 },
      format: (value) => formatCurrency(value, quotation.currency || 'USD'),
    },
    {
      key: 'total_amount',
      label: 'Total Amount',
      type: 'currency',
      validation: { min: 0 },
      format: (value) => formatCurrency(value, quotation.currency || 'USD'),
    },
    { key: 'shipping_method', label: 'Shipping Method' },
  ];

  const nonEditableFields = [
    { key: 'deal_id', label: 'Deal' },
  ];

  const additionalFields = [
    { key: 'quote_date', label: 'Quote Expiration Date', type: 'date', value: quotation.quote_date },
    { key: 'notes', label: 'Notes', type: 'text', value: quotation.notes },
  ];

  // Shared by the classic and v2 layouts below: the same actions, field
  // sections and side column render in both.
  const recordActions = (
    <>

      {/* Email Button */}
      {/* {quotation.status !== 'Draft' && ( */}
      <Tooltip title="Send Email" placement="top">
        <IconButton
          onClick={handleToggleEmailModal}
          disabled={isEmailLoading}
          sx={{
            background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
            borderRadius: '50%',
            padding: '8px',
            '&:hover': {
              background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
              transform: 'translateY(-2px)',
              boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          {isEmailLoading ? (
            <CircularProgress size={20} sx={{ color: '#ffffff' }} />
          ) : (
            <Email sx={{ color: '#ffffff', fontSize: 20 }} />
          )}
        </IconButton>
      </Tooltip>
      {/* )} */}

      {/* Edit Button */}
      {quotation.status !== 'Accepted' && quotation.status !== 'Rejected' && !isEditing && (
        <Tooltip title="Edit Quote" placement="top">
          <IconButton
            onClick={handleEditToggle}
            disabled={isEditLoading}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              borderRadius: '50%',
              padding: '8px',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                transform: 'translateY(-2px)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {isEditLoading ? (
              <CircularProgress size={20} sx={{ color: '#ffffff' }} />
            ) : (
              <Edit sx={{ color: '#ffffff', fontSize: 20 }} />
            )}
          </IconButton>
        </Tooltip>
      )}

      {/* Edit Mode Buttons */}
      {isEditing && (
        <Box sx={{ display: 'flex', gap: 2 }}>
          <MDButton
            variant="contained"
            onClick={() => setIsEditing(false)}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              color: '#ffffff',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                transform: 'translateY(-2px)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
            startIcon={<Close />}
          >
            Discard
          </MDButton>

          <MDButton
            variant="contained"
            onClick={handleSaveChanges}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              color: '#ffffff',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                transform: 'translateY(-2px)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
            startIcon={<Save />}
          >
            Save
          </MDButton>
        </Box>
      )}

      {/* Mark Rejected Button */}
      {quotation.status === 'Accepted' && (
        <Tooltip title="Mark Rejected" placement="top">
          <IconButton
            onClick={() => handleStatusChange('Rejected')}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              borderRadius: '50%',
              padding: '8px',
              '&:hover': {
                background: 'linear-gradient(145deg, #d9534f, #c9302c)',
                transform: 'translateY(-2px)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
          >
            <ErrorOutlineIcon sx={{ color: '#ffffff', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      )}

      {/* Clone Button */}
      {!isEditing && (
        <Tooltip title="Clone Quote" placement="top">
          <IconButton
            onClick={handleCloneClick}
            disabled={isCloneLoading}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              borderRadius: '50%',
              padding: '8px',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                transform: 'translateY(-2px)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {isCloneLoading ? (
              <CircularProgress size={20} sx={{ color: '#ffffff' }} />
            ) : (
              <FileCopy sx={{ color: '#ffffff', fontSize: 20 }} />
            )}
          </IconButton>
        </Tooltip>
      )}

      {/* Download PDF Button */}
      {!isEditing && (quotation.status === 'Sent' || quotation.status === 'Accepted') && (
        <Tooltip title="Download PDF" placement="top">
          <IconButton
            onClick={handlePdfDownload}
            disabled={isDownloading}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              borderRadius: '50%',
              padding: '8px',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                transform: 'translateY(-2px)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {isDownloading && downloadLoadingId === quotation.id ? (
              <CircularProgress size={20} sx={{ color: '#ffffff' }} />
            ) : (
              <PictureAsPdf sx={{ color: '#ffffff', fontSize: 20 }} />
            )}
          </IconButton>
        </Tooltip>
      )}

      {/* Delete Button */}
      {!isEditing && quotation.status !== 'Accepted' && (
        <Tooltip title="Delete Quote" placement="top">
          <IconButton
            onClick={handleOpenDeleteModal} // Changed from handleDelete to handleOpenDeleteModal
            disabled={isDeleting}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              borderRadius: '50%',
              padding: '8px',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                transform: 'translateY(-2px)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {isDeleting ? (
              <CircularProgress size={20} sx={{ color: '#ffffff' }} />
            ) : (
              <Delete sx={{ color: '#ffffff', fontSize: 20 }} />
            )}
          </IconButton>
        </Tooltip>
      )}
    </>
  );
  const recordDetailsBody = (
    <>
      {visibleSections.map(sectionLabel => {
        if (sectionLabel === 'Quotation Information') {
          const quotationInfoFields = {};

          // Collect editable fields
          fieldsConfig.forEach(({ key, label, type, format }) => {
            let value = quotation[key];

            if (type === 'currency' && format) {
              value = format(value);
            } else if (key === 'account_name' || (type === 'link' && key === 'account_name')) {
              // Debug logging to understand the data structure
              // console.log('Account linking debug:', {
              //   quotation: quotation,
              //   dealDetails: dealDetails,
              //   accountIdFromDeal: dealDetails?.account_id,
              //   accountIdFromQuotation: quotation.account_id,
              //   quotationKeys: Object.keys(quotation),
              //   dealDetailsKeys: dealDetails ? Object.keys(dealDetails) : 'No deal details'
              // });

              const accountId = dealDetails?.account_id || quotation.account_id || quotation.accountId;

              // Only create link if we have a valid account ID
              if (accountId) {
                value = (
                  <Link to={`/accounts/${accountId}`} style={{ textDecoration: 'none' }}>
                                  <MDTypography fontWeight="medium" color="info" sx={{ lineHeight: 1.2, fontSize: '0.9rem' }}>
                    {(quotation.account_name || '').charAt(0).toUpperCase() + (quotation.account_name || '').slice(1).toLowerCase()}
                  </MDTypography>
                  </Link>
                );
              } else {
                // If no account ID, just show the name without link
                value = (
                  <MDTypography fontWeight="medium" color="text" sx={{ lineHeight: 1.2, fontSize: '0.9rem' }}>
                    {(quotation.account_name || '').charAt(0).toUpperCase() + (quotation.account_name || '').slice(1).toLowerCase()}
                  </MDTypography>
                );
              }
            }

            quotationInfoFields[label] = value;
          });

          // Add non-editable fields
          nonEditableFields.forEach(({ key, label }) => {
            quotationInfoFields[label] = key === 'deal_id' ? (
              <Link
                to={`/deals/${quotation.deal_id}`}
                style={{ textDecoration: 'none' }}
              >
                <MDTypography fontWeight="medium" color="info" sx={{ lineHeight: 1.2, fontSize: '0.9rem' }}>
                  {(dealDetails?.name || '').charAt(0).toUpperCase() + (dealDetails?.name || '').slice(1).toLowerCase()}
                </MDTypography>
              </Link>
            ) : (
              quotation[key]
            );
          });

          // Add additional fields
          additionalFields.forEach(({ key, label, type, value }) => {
            quotationInfoFields[label] = type === 'date' && value ? formatDate(value) : value;
          });

          return renderDetailCard('Quotation Information', quotationInfoFields);
        }

        if (sectionLabel === 'Shipping & Payment') {
          return renderDetailCard('Shipping & Payment', {
            "Billing Address": quotation.billing_address,
            "Shipping Address": quotation.shipping_address,
            "Shipping Method": quotation.shipping_method,
            "Delivery Date": formatDate(quotation.delivery_date),
            "Notes": quotation.shipping_instruction,
          });
        }

        if (sectionLabel === 'Transport Details') {
          return renderDetailCard('Transport Details', {
            "Transporter ID": quotation.transid || '-',
            "Transporter Name": quotation.transname || '-',
            "Transport Mode": transportModeMapping[quotation.transmode] || quotation.transmode,
            ...(quotation.transmode === '1' && {
              "Vehicle Number": quotation.vehno || '-',
              "Vehicle Type": vehicleTypeMapping[quotation.vehtype] || quotation.vehtype || '-',
            }),
            ...(quotation.transmode === '4' && {
              "Vehicle Number": quotation.vehno || '-',
              "Transport Document Number": quotation.transdocno || '-',
            }),
            ...(['2', '3'].includes(quotation.transmode) && {
              "Transport Document Number": quotation.transdocno || '-',
            }),
          });
        }

        if (sectionLabel === 'Custom Field Information' && customFields?.length > 0) {
          return renderDetailCard(
            'Custom Field Information',
            [],
            <CustomFieldsSection
              ref={customFieldsRef}
              objectType="quotations"
              objectData={editedFields}
              isEditing={isEditing}
              onFieldUpdate={handleFieldUpdate}
              onError={handleFieldError}
              formErrors={formErrors}
            />
          );
        }

        if (sectionLabel === 'Quotation Items') {
          return (
            <MDBox
              // m={3}
              p={3}
              borderRadius="lg"
              sx={{
                backgroundColor: 'white',
                boxShadow: 3,
                maxWidth: '100%',
                width: 'auto'
              }}
            >
              <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <MDTypography variant="h6" fontWeight="medium" color="dark">
                  Quotation Items
                </MDTypography>
              </MDBox>

              <MDBox
                sx={{
                  mt: 3,
                  mb: 3,
                  border: "1px solid #dee2e6",
                  borderRadius: "0.75rem",
                  overflow: "auto",
                  maxHeight: "400px",
                }}
              >
                {/* Header */}
                <MDBox
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "25% 15% 10% 12% 15% 10% 13%",
                    bgcolor: "#f8f9fa",
                    borderBottom: "1px solid #dee2e6",
                    p: 2,
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    minWidth: 'max-content'
                  }}
                >
                  <MDBox sx={{ px: 1 }}>
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Product Name
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ px: 1, textAlign: "right" }}>
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Unit Price
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ px: 1, textAlign: "right" }}>
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Tax %
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ px: 1, textAlign: "right" }}>
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Discount %
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ px: 1, textAlign: "right" }}>
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Discounted Price
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ px: 1, textAlign: "right" }}>
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Quantity
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ px: 1, textAlign: "right" }}>
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Total Net Price
                    </MDTypography>
                  </MDBox>
                </MDBox>

                {/* Body */}
                {quotationItems.map((item, index) => {
                  const discountedPrice = item.price - (item.price * (item.discount_percentage / 100));
                  const totalNetPrice = discountedPrice * item.quantity;
                  return (
                    <MDBox
                      key={index}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "25% 15% 10% 12% 15% 10% 13%",
                        borderBottom: '1px solid #dee2e6',
                        p: 2,
                        '&:hover': { backgroundColor: '#f8f9fa' },
                        transition: 'background-color 0.2s',
                        minWidth: 'max-content'
                      }}
                    >
                      <MDBox sx={{ px: 1 }}>
                        <MDTypography
                          variant="button"
                          color="text"
                          sx={{
                            display: "block",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            lineHeight: 1.35,
                          }}
                        >
                          {item.product_name}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ px: 1, textAlign: "right" }}>
                        <MDTypography variant="button" color="text">
                          {formatCurrency(parseFloat(item.price), quotation.currency)}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ px: 1, textAlign: "right" }}>
                        <MDTypography variant="button" color="text">
                          {item.tax}%
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ px: 1, textAlign: "right" }}>
                        <MDTypography variant="button" color="text">
                          {item.discount_percentage}%
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ px: 1, textAlign: "right" }}>
                        <MDTypography variant="button" color="text">
                          {formatCurrency(parseFloat(discountedPrice), quotation.currency)}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ px: 1, textAlign: "right" }}>
                        <MDTypography variant="button" color="text">
                          {item.quantity}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ px: 1, textAlign: "right" }}>
                        <MDTypography variant="button" color="text">
                          {formatCurrency(parseFloat(totalNetPrice), quotation.currency)}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  );
                })}

                {/* Footer */}
                <MDBox
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "85% 15%",
                    borderTop: '2px solid #dee2e6',
                    p: 2,
                    minWidth: 'max-content',
                    backgroundColor: 'white'
                  }}
                >
                  <MDBox textAlign="right">
                    <MDTypography variant="button" fontWeight="medium" color="dark">
                      Total
                    </MDTypography>
                  </MDBox>
                  <MDBox textAlign="right">
                    <MDTypography variant="button" fontWeight="medium" color="dark">
                      {formatCurrency(parseFloat(quotation.total_amount), quotation.currency)}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
          );
        }

        if (sectionLabel === 'Audit Information') {
          const auditInfoFields = {};
          auditFields.forEach(({ label, field, userIdField }) => {
            let value = quotation[field];

            if (field === 'created_at' || field === 'updated_at') {
              value = formatDate(value);
            }

            if (userIdField) {
              value = (
                <Link to={`/users/${quotation[userIdField]}/profile`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <MDTypography color="info" sx={{ fontSize: '0.9rem', fontWeight: 'medium' }}>
                    {quotation[field] || ' '}
                  </MDTypography>
                </Link>
              );
            }

            auditInfoFields[label] = value;
          });

          return renderDetailCard('Audit Information', auditInfoFields);
        }

        return null;
      })}
    </>
  );
  // Side-column pieces, named so the v2 record layout can place them in its
  // tabs and side column; recordSideColumn below keeps the classic order.
  const quoteActivitiesCard = (
    <>
      {hasTasksModule && (
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EventIcon sx={{ color: 'white !important', mr: 1 }} />
            <MDTypography variant="h6" color="white">
              Activities
            </MDTypography>
          </Box>
          <MDButton variant="gradient" color="dark" onClick={handleOpenActivityModal}>
            Add Activity
          </MDButton>
        </MDBox>
        <MDBox p={2}>
          {isActivitiesLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <CircularProgress size={24} color="info" />
            </Box>
          ) : (
            <Activities
              activities={activities.filter(Boolean)}
              onDelete={handleDeleteActivity}
              onEdit={handleEditActivity}
            />
          )}
        </MDBox>
      </Card>
      )}
    </>
  );

  // Attachments.
  const quoteAttachmentsCard = (
    <>
      <Card style={{ marginTop: '10px' }}>
        <MDBox
          mx={2}
          mt={-2}
          py={2}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AttachmentIcon sx={{ color: 'white !important', mr: 1 }} />
            <MDTypography variant="h6" color="white">
              Attachments
            </MDTypography>
          </Box>
          <MDButton variant="gradient" color="dark" onClick={() => setIsAttachmentModalOpen(true)}>
            Add Attachment
          </MDButton>
        </MDBox>
        <MDBox p={2}>
          <Attachments
            attachments={attachments}
            onDelete={handleDeleteAttachment}
            onDownload={handleDownloadAttachment}
          />
        </MDBox>
      </Card>
    </>
  );

  // Upload dialog for Attachments.
  const quoteAttachmentUploadModal = (
    <>
      <AttachmentUploadModal
        isOpen={isAttachmentModalOpen}
        onClose={() => setIsAttachmentModalOpen(false)}
        onUpload={handleUploadSuccess}
        axiosInstance={axiosInstance}
      />
    </>
  );

  // Echo feed.
  const quoteEchoFeedCard = (
    <>
      <Card style={{ marginTop: '10px' }}>
        <MDBox
          mx={2}
          mt={-2}
          py={2}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <RecordVoiceOverIcon sx={{ color: 'white !important', mr: 1 }} />
            <MDTypography variant="h6" color="white">
              Echo Feed
            </MDTypography>
          </Box>
          <MDButton 
            variant="gradient" 
            color="dark"
            onClick={handleOpenEchoModal}
          >
            Add Message
          </MDButton>
        </MDBox>

        <MDBox p={2}>
          {/* EchoComposer removed, replaced by modal */}
          <Modal
            open={isEchoModalOpen}
            onClose={handleCloseEchoModal}
            aria-labelledby="echo-modal-title"
            aria-describedby="echo-modal-description"
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              bgcolor: 'background.paper',
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
            }}>
              <MDTypography id="echo-modal-title" variant="h6" mb={2}>
                Post a Feed
              </MDTypography>
              <EchoComposer
                onSubmit={handleEchoSubmit}
                onCancel={handleCloseEchoModal}
                placeholder="Type @ to mention users..."
                axiosInstance={axiosInstance}
                objectType="quotations"
                objectId={id}
                onError={(message) => setSnackbar({
                  open: true,
                  message: `Error creating feed item: ${message}`,
                  severity: 'error',
                })}
              />
            </Box>
          </Modal>
          {/* Display feed items */}
          <Box mt={3}>
            {isFeedLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                <CircularProgress size={24} color="info" />
              </Box>
            ) : feedItems.length > 0 ? (
              <Box className="pearl-echo-feed" sx={{ 
                maxHeight: 400, 
                overflowY: 'auto',
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                backgroundColor: '#fafafa'
              }}>
                {feedItems.map((item, index) => (
                  <Box 
                    key={item.id} 
                    sx={{ 
                      p: 2, 
                      borderBottom: index < feedItems.length - 1 ? '1px solid #e0e0e0' : 'none',
                      backgroundColor: 'white',
                      '&:hover': {
                        backgroundColor: '#f8f9fa'
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                      {(() => {
                        const nameParts = extractNameParts(item.created_by_user, item.created_by_name);
                        return (
                          <MDUserAvatar
                            firstName={nameParts.firstName}
                            middleName={nameParts.middleName}
                            lastName={nameParts.lastName}
                            avatarUrl={nameParts.avatarUrl}
                            size={36}
                            variant="circular"
                            sx={{ mr: 2, flexShrink: 0 }}
                          />
                        );
                      })()}
                      <Box sx={{ flex: 1, minWidth: 0, ml:2  }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography 
                              variant="subtitle2" 
                              fontWeight="medium"
                              sx={{ 
                                color: 'primary.main',
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}
                              onClick={() => {
                                // Navigate to user profile
                                const userMention = item.feeditem.mentions?.find(m => m.type === 'user' && m.entity_name === item.created_by_name);
                                if (userMention) {
                                  navigate(`/users/${userMention.entity_id}/profile`);
                                }
                              }}
                            >
                              {item.created_by_user?.full_name || item.created_by_name}
                            </Typography>
                            <Typography 
                              variant="caption" 
                              color="text.secondary" 
                              sx={{ ml: 1 }}
                            >
                              {formatDate(item.updated_at, 'datetime')}
                            </Typography>
                          </Box>

                          {/* Edit/Delete buttons - only show for current user's messages */}
                          {item.created_by === user?.id && (
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                              <Tooltip title="Edit message" arrow>
                                <MDButton
                                  size="small"
                                  variant="text"
                                  color="info"
                                  onClick={() => startEditFeedItem(item)}
                                  disabled={isEditingFeed}
                                  sx={{ minWidth: 'auto', p: 0.5 }}
                                >
                                  <EditIcon fontSize="small" />
                                </MDButton>
                              </Tooltip>
                              <Tooltip title="Delete message" arrow>
                                <MDButton
                                  size="small"
                                  variant="text"
                                  color="error"
                                  onClick={() => handleDeleteConfirm(item)}
                                  disabled={isEditingFeed}
                                  sx={{ minWidth: 'auto', p: 0.5 }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </MDButton>
                              </Tooltip>
                            </Box>
                          )}
                        </Box>

                        {editingFeedItem === item.id ? (
                          <Box sx={{ mt: 1 }}>
                            <EchoComposer
                              value={editFeedContent}
                              onChange={setEditFeedContent}
                              placeholder="Edit your message..."
                              axiosInstance={axiosInstance}
                              objectType="quotations"
                              objectId={id}
                              feedItemId={item.id}
                              isEditMode={true}
                              onSubmit={handleEditFeedItem}
                              onCancel={cancelEditFeedItem}
                              onSuccess={() => {
                                // Auto-save when user clicks the Update button in EchoComposer
                                setEditingFeedItem(null);
                                setEditFeedContent('');
                              }}
                              sx={{ 
                                mb: 1,
                                '& .MuiInputBase-root': {
                                  backgroundColor: 'white'
                                }
                              }}
                            />
                          </Box>
                        ) : (
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              whiteSpace: 'pre-wrap',
                              lineHeight: 1.5,
                              color: 'text.primary'
                            }}
                          >
                            {parseFeedContent(item)}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            ) : (
              <Box sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: -2,
              }}>
                <Box sx={{
                   width: 50,
                      height: 50,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(0,0,0,0.04)',
                      mb: 1.5
                    }}>
                      <RecordVoiceOverIcon sx={{ color: 'text.secondary', fontSize: 24,}} />
                </Box>

                <Typography variant="body2" sx={{ mb: 1 }}>
                  No messages yet
                </Typography>
                 {/* <Typography variant="caption">
                  Start a conversation by typing a message above
                </Typography> */}
              </Box>
            )}
          </Box>
        </MDBox>
      </Card>
    </>
  );

  const recordSideColumn = (
    <>
      {quoteActivitiesCard}
      {hasTasksModule && <br />}
      {quoteAttachmentsCard}
      {quoteAttachmentUploadModal}
      <br />
      {/* Echo/Feed Card */}
      {quoteEchoFeedCard}
    </>
  );

  // v2: the quote laid out like Account 360 (components/v2/record). The
  // pieces are the ones the classic page renders; line items stay in the
  // field sections on Overview.
  const lastQuoteActivity = activities.map((a) => a?.created_at).filter(Boolean).sort().pop();
  const quoteTotal = quotation?.total_amount != null && quotation?.total_amount !== '' ? formatCurrency(quotation.total_amount, quotation.currency || 'USD') : '—';
  const v2Main = (
    <MDBox>
      <RecordPageV2
        sectionsLabel="Quote sections"
        hero={{
          label: 'Quote summary',
          icon: FileText,
          eyebrow: 'Quote',
          title: quotation?.quote_name || '',
          animate: isCloning,
          actions: recordActions,
          badges: quotation?.status ? <StatusBadge status={quotation.status} /> : null,
          meta: [
            { key: 'deal', icon: Briefcase, content: quotation?.deal_name && quotation?.deal_id ? (
              <Link to={`/deals/${quotation.deal_id}`} style={{ color: 'inherit', fontWeight: 600 }}>{quotation.deal_name}</Link>
            ) : quotation?.deal_name || null },
            { key: 'account', icon: Building2, content: quotation?.account_name && quotation?.account_id ? (
              <Link to={`/accounts/${quotation.account_id}`} style={{ color: 'inherit', fontWeight: 600 }}>{quotation.account_name}</Link>
            ) : quotation?.account_name || null },
            { key: 'expires', icon: CalendarDays, content: quotation?.quote_date ? `Valid until ${formatDate(quotation.quote_date, 'date')}` : null },
          ],
        }}
        tiles={[
          { key: 'total', icon: CircleDollarSign, label: 'Total', value: quoteTotal },
          { key: 'status', icon: CircleDot, label: 'Status', value: quotation?.status || '—' },
          { key: 'expires', icon: CalendarDays, label: 'Expires', value: quotation?.quote_date ? formatDate(quotation.quote_date, 'date') : '—' },
          { key: 'items', icon: ListOrdered, label: 'Items', value: String(quotationItems.length) },
          { key: 'last', icon: Clock, label: 'Last activity', value: relativeTime(lastQuoteActivity) || 'None yet', tab: 'activity' },
        ]}
        tabs={[
          {
            key: 'overview',
            label: 'Overview',
            icon: LayoutGrid,
            render: () => (
              <Card>
                <MDBox p={3}>
                  {recordDetailsBody}
                </MDBox>
              </Card>
            ),
          },
          {
            key: 'activity',
            label: 'Activity',
            icon: History,
            count: hasTasksModule ? activities.filter(Boolean).length : undefined,
            render: () => (
              <TabStack>
                {quoteActivitiesCard}
                {quoteEchoFeedCard}
              </TabStack>
            ),
          },
          { key: 'files', label: 'Files', icon: Paperclip, count: attachments.length, render: () => quoteAttachmentsCard },
        ]}
        aside={(selectTab) => (
          <ActivityTimeline activities={activities} feedItems={feedItems} onOpenAll={() => selectTab('activity')} emptyText="No activity on this quote yet." />
        )}
      />
      {quoteAttachmentUploadModal}
    </MDBox>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isV2 ? v2Main : (
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >

                <MDTypography variant="h6" color="white">
                  {quotation?.quote_name}
                </MDTypography>
                <MDBox>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    {recordActions}
                  </Box>
                </MDBox>

              </MDBox>
              <MDBox p={3}>
                {recordDetailsBody}
</MDBox>


            </Card>
          </Grid>

          {/* <Grid item xs={12} md={4}>
           
          </Grid>
          <br />
          <br /> */}
          <Grid item xs={12} md={4}>
            {recordSideColumn}
          </Grid>
        </Grid>
      </MDBox>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>


      <Dialog
        open={isEditCardOpen}
        onClose={() => setIsEditCardOpen(false)}
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle>Edit Quotation</DialogTitle>

        <DialogContent>
          <MDBox display="flex" flexDirection="column" mt={2}>

            <Grid container spacing={2}>

              {/* Editable Fields */}
              {[
                // { key: 'deal_name', label: 'Quote Name', readOnly: true },

                {
                  key: 'account_name',
                  label: 'Account',
                  type: 'autocomplete',
                  options: accountOptions,
                },
                {
                  key: 'status',
                  label: 'Status',
                  type: 'select',
                  options: [
                    { value: 'Draft', label: 'Draft', color: '#FFC107' },
                    { value: 'Sent', label: 'Sent', color: '#2196F3' },
                    { value: 'Accepted', label: 'Accepted', color: '#4CAF50' },
                    { value: 'Rejected', label: 'Rejected', color: '#F44336' },
                  ],
                },
                {
                  key: 'quote_date',
                  label: 'Quote Expiration Date',
                  type: 'date',
                  value: editedFields.quote_date || ''
                },
                { key: 'shipping_method', label: 'Shipping Method' },
                // { key: 'subtotal', label: 'Subtotal', type: 'currency', value: subtotal.toFixed(2) },
                // { key: 'total_amount', label: 'Grand Total', type: 'currency', value: totalAmount.toFixed(2) },
              ].map(({ key, label, type, options, value }) => (
                <Grid item xs={6} key={key}>
                  {type === 'autocomplete' ? (
                    <Autocomplete
                      options={options}
                      value={editedFields[key] || value || ''}
                      onChange={(e, newValue) => handleFieldChange(key, newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={label}
                          fullWidth
                          sx={{ height: '45px', '& .MuiInputBase-root': { height: '45px' } }} // Adjust height here
                        />
                      )}
                    />
                  ) : type === 'date' ? (
                    <TextField
                      label={label}
                      type="date"
                      value={value || editedFields[key] || ''}
                      onChange={(e) => handleFieldChange(key, e.target.value)}
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        height: '56px',
                        '& .MuiInputBase-root': {
                          height: '45px',
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      label={label}
                      value={value || editedFields[key] || ''}
                      onChange={(e) => handleFieldChange(key, e.target.value)}
                      fullWidth
                      type={type === 'currency' ? 'text' : 'text'}
                      InputProps={
                        type === 'currency'
                          ? { startAdornment: <InputAdornment position="start">{getCurrencySymbol('EUR')}</InputAdornment> }
                          : {}
                      }
                      select={type === 'select'}
                      SelectProps={
                        type === 'select'
                          ? {
                              renderValue: (selected) => {
                                const selectedOption = options.find((option) => option.value === selected);
                                if (!selectedOption) return selected;
                                return (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Box
                                      sx={{
                                        width: 12,
                                        height: 12,
                                        backgroundColor: selectedOption.color,
                                        borderRadius: '50%',
                                        flexShrink: 0,
                                      }}
                                    />
                                    {selectedOption.label}
                                  </Box>
                                );
                              },
                            }
                          : undefined
                      }
                      sx={{
                        height: '56px',
                        '& .MuiInputBase-root': {
                          height: '45px',
                          alignItems: 'center',
                        },
                        '& .MuiSelect-select': {
                          display: 'flex',
                          alignItems: 'center',
                        },
                      }}
                    >
                      {type === 'select' && options.map((option) => (
                        <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box
                              sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: option.color,
                                borderRadius: '50%',
                                flexShrink: 0,
                              }}
                            />
                            {option.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>
              ))}
            </Grid>

            {customFields && customFields.length > 0 && (
              <Grid item xs={12}>
                <MDTypography variant="h6" gutterBottom>
                  Custom Fields
                </MDTypography>
                {renderCustomFields()}
              </Grid>
            )}



            <MDTypography variant="h6" fontWeight="medium" mt={3}>
              Edit Products
            </MDTypography>

            <MDBox
              sx={{
                mt: 3,
                mb: 3,
                border: "1px solid #dee2e6",
                borderRadius: "0.75rem",
                overflow: "auto",
                maxHeight: "400px"
              }}
            >
              {/* Header */}
              <MDBox
                sx={{
                  display: "flex",
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #dee2e6",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  minWidth: '1000px'
                }}
              >
                <MDBox width="15%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Product Name
                  </MDTypography>
                </MDBox>
                <MDBox width="10%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Unit Price
                  </MDTypography>
                </MDBox>
                <MDBox width="10%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Tax %
                  </MDTypography>
                </MDBox>
                <MDBox width="15%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Discount %
                  </MDTypography>
                </MDBox>
                <MDBox width="15%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Discounted Price
                    <Tooltip
                      title="Discounted Price = (Unit Price - Discount %)"
                      arrow
                    >
                      <IconButton size="small" sx={{ marginLeft: 0.3 }}>
                        <InfoIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </MDTypography>
                </MDBox>
                <MDBox width="10%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Quantity
                  </MDTypography>
                </MDBox>
                <MDBox width="15%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Total Net Price
                    <Tooltip
                      title="Total Net Price = Discounted Price * Quantity"
                      arrow
                    >
                      <IconButton size="small" sx={{ marginLeft: 0.3 }}>
                        <InfoIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </MDTypography>
                </MDBox>
                <MDBox width="10%" p={2} textAlign="center">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Actions
                  </MDTypography>
                </MDBox>
              </MDBox>


              {/* Body */}
              <MDBox sx={{ minWidth: '1000px' }}>
                {products.map((product, index) => (
                  <MDBox
                    key={index}
                    display="flex"
                    sx={{
                      borderBottom: "1px solid #dee2e6",
                      '&:hover': { backgroundColor: '#f8f9fa' }
                    }}
                  >
                    <MDBox width="15%" p={2} textAlign="center">
                      <Autocomplete
                        value={product.name}
                        options={suggestions.names}
                        onChange={(e, newValue) => handleProductChange(index, 'name', newValue)}
                        PopperComponent={(props) => (
                          <Popper {...props} style={{ maxHeight: 500 }} />
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#dee2e6' },
                                '&:hover fieldset': { borderColor: '#7b809a' }
                              }
                            }}
                          />
                        )}
                      />
                    </MDBox>
                    <MDBox width="10%" p={2} textAlign="center">
                      {editingPriceIndex === index ? (
                        <TextField
                          value={editingPriceValue}
                          onChange={(e) => {
                            const newPrice = parseFloat(e.target.value) || 0;
                            setEditingPriceValue(e.target.value);
                            handleUnitPriceChange(index, newPrice);
                          }}
                          onBlur={() => {
                            setEditingPriceIndex(null);
                            setEditingPriceValue('');
                          }}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              setEditingPriceIndex(null);
                              setEditingPriceValue('');
                            }
                          }}
                          size="small"
                          sx={{ 
                            width: '100%',
                            '& .MuiInputBase-root': {
                              height: '32px',
                              fontSize: '0.875rem'
                            }
                          }}
                          inputProps={{ 
                            type: 'number', 
                            step: '0.01', 
                            min: '0',
                            style: { textAlign: 'center' }
                          }}
                          autoFocus
                        />
                      ) : (
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          width: '100%'
                        }}>
                          <MDTypography variant="button" fontWeight="regular">
                            {formatCurrency(product.price || 0, quotation.currency)}
                          </MDTypography>
                          <Tooltip title="Edit Unit Price">
                            <IconButton
                              size="small"
                              onClick={() => handleStartPriceEdit(index, product.price || 0)}
                              sx={{ 
                                color: 'text.secondary',
                                '&:hover': { color: 'primary.main' },
                                width: '24px',
                                height: '24px'
                              }}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                    </MDBox>
                    <MDBox width="10%" p={2} textAlign="center">
                      <MDTypography variant="button" fontWeight="regular">
                        {parseFloat(product.tax_rate || 0).toFixed(2)}%
                      </MDTypography>
                    </MDBox>
                    <MDBox width="15%" p={2} textAlign="center">
                      <TextField
                        type="number"
                        value={product.discount_percentage}
                        onChange={(e) => {
                          let value = parseFloat(e.target.value);
                          if (isNaN(value)) value = 0;
                          value = Math.min(Math.max(value, 0), 100);
                          handleProductChange(index, 'discount_percentage', value);
                        }}
                        inputProps={{ min: 0, max: 100 }}
                        size="small"
                        sx={{
                          width: '80px',
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: '#dee2e6' },
                            '&:hover fieldset': { borderColor: '#7b809a' }
                          }
                        }}
                      />
                    </MDBox>
                    <MDBox width="15%" p={2} textAlign="center">
                      <MDTypography variant="button" fontWeight="regular">
                        {formatCurrency(product.discounted_price || 0, quotation.currency)}
                      </MDTypography>
                    </MDBox>
                    <MDBox width="10%" p={2} textAlign="center">
                      <TextField
                        type="number"
                        value={product.quantity}
                        onChange={(e) => handleProductChange(index, 'quantity', e.target.value)}
                        size="small"
                        sx={{
                          width: '80px',
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: '#dee2e6' },
                            '&:hover fieldset': { borderColor: '#7b809a' }
                          }
                        }}
                      />
                    </MDBox>
                    <MDBox width="15%" p={2} textAlign="center">
                      <MDTypography variant="button" fontWeight="regular">
                        {formatCurrency(product.total_price || 0, quotation.currency)}
                      </MDTypography>
                    </MDBox>
                    <MDBox width="10%" p={2} textAlign="center" display="flex" justifyContent="center" alignItems="center">
                      <IconButton
                        onClick={() => handleRemoveProduct(index)}
                        color="error"
                        size="small"
                      >
                        <RemoveIcon />
                      </IconButton>
                      <IconButton
                        color="info"
                        onClick={handleAddProduct}
                        size="small"
                      >
                        <AddIcon />
                      </IconButton>
                    </MDBox>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox>
          </MDBox>

          {/* Subtotal, Tax Summary, and Grand Total */}
          {/* <MDBox
            sx={{
              mt: 3,
              p: 2,
              borderTop: '2px solid #dee2e6',
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <MDBox sx={{ minWidth: '300px' }}>
              <MDBox display="flex" justifyContent="space-between" mb={1}>
                <MDTypography variant="button" color="text" fontWeight="regular">
                  Subtotal:
                </MDTypography>
                <MDTypography variant="button" color="text" fontWeight="medium">
                {getCurrencySymbol(dealCurrency)}{formatIndianNumber(subtotal || 0)}
                </MDTypography>
              </MDBox>

              {Object.entries(taxSummary).map(([taxRate, amount]) => (
                <MDBox key={taxRate} display="flex" justifyContent="space-between" mb={1}>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    Tax ({taxRate}%):
                  </MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="medium">
                  {getCurrencySymbol(dealCurrency)}{formatIndianNumber(amount || 0)}
                  </MDTypography>
                </MDBox>
              ))}

              <MDBox
                display="flex"
                justifyContent="space-between"
                mt={2}
                pt={1.5}
                sx={{ borderTop: '1px solid #dee2e6' }}
              >
                <MDTypography variant="button" color="dark" fontWeight="medium">
                  Grand Total:
                </MDTypography>
                <MDTypography variant="button" color="info" fontWeight="bold">
                {getCurrencySymbol(dealCurrency)}{formatIndianNumber(subtotal + Object.values(taxSummary).reduce((acc, curr) => acc + curr, 0) || 0)}
                </MDTypography>
              </MDBox>
            </MDBox> */}

          {/* Subtotal, Tax Summary, and Grand Total */}
          <MDBox
            sx={{
              mt: 3,
              p: 2,
              borderTop: '2px solid #dee2e6',
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <MDBox sx={{ minWidth: '300px' }}>
              <MDBox display="flex" justifyContent="space-between" mb={1}>
                <MDTypography variant="button" color="text" fontWeight="regular">
                  Subtotal:
                </MDTypography>
                <MDTypography variant="button" color="text" fontWeight="medium">
                  {formatCurrency(subtotal || 0, quotation.currency)}
                </MDTypography>
              </MDBox>

              {Object.entries(taxSummary).map(([taxRate, amount]) => (
                <MDBox key={taxRate} display="flex" justifyContent="space-between" mb={1}>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    Tax ({taxRate}%):
                  </MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="medium">
                    {formatCurrency(amount || 0, quotation.currency)}
                  </MDTypography>
                </MDBox>
              ))}

              <MDBox
                display="flex"
                justifyContent="space-between"
                mt={2}
                pt={1.5}
                sx={{ borderTop: '1px solid #dee2e6' }}
              >
                <MDTypography variant="button" color="dark" fontWeight="medium">
                  Grand Total:
                </MDTypography>
                <MDTypography variant="button" color="info" fontWeight="bold">
                  {formatCurrency(subtotal + Object.values(taxSummary).reduce((acc, curr) => acc + curr, 0) || 0, quotation.currency)}
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>

        </DialogContent>

        <DialogActions>
          <MDButton
            onClick={() => setIsEditCardOpen(false)}
            variant="outlined"
            color="secondary"
            disabled={isSaving}
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={handleSaveChanges}
            variant="gradient"
            color="info"
            disabled={isSaving}
            startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </MDButton>
        </DialogActions>

      </Dialog>


      <Dialog
        open={openInvoiceDialog}
        onClose={() => setOpenInvoiceDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: currentInvoiceHtml }} />
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenInvoiceDialog(false)} color="primary">
            Close
          </MDButton>
        </DialogActions>
      </Dialog>

      <CloneQuotationModal
        open={isCloneModalOpen}
        onClose={() => setIsCloneModalOpen(false)}
        quotation={quotation}
        onClone={handleClone}
        suggestions={suggestions}
        // Add these new props
        customFields={customFields}
        customFieldsRef={customFieldsRef}
        formErrors={formErrors}
        onFieldUpdate={handleFieldUpdate}
        onFieldError={handleFieldError}
        // Include the custom fields data
        initialCustomFields={{
          ...quotation?.custom_fields,
          ...Object.entries(quotation || {})
            .filter(([key]) => key.startsWith('cf_'))
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
        }}
      />

      <Dialog
        open={isCreateOrderModalOpen}
        onClose={() => setIsCreateOrderModalOpen(false)}
      >
        <DialogTitle>Create Order</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to create an order from this quotation?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsCreateOrderModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleCreateOrder();
              setIsCreateOrderModalOpen(false);
              setSnackbar({
                open: true,
                message: 'Order created successfully!',
                severity: 'success'
              });
            }}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <EmailModal
        open={isEmailModalOpen}
        onClose={handleToggleEmailModal}
        newEmail={newEmail}
        setNewEmail={setNewEmail}
        handleSend={handleSendEmail}
        isGenerating={isGenerating}
        isSending={isEmailSending}
        errorMessage={errorMessage}
        emailContext={emailContext}
        setEmailContext={setEmailContext}
        handleGenerateEmail={handleGenerateEmail}
        showCc={showCc}
        showBcc={showBcc}
        toggleCc={toggleCc}
        toggleBcc={toggleBcc}
        handleQuillChange={handleQuillChange}
        modules={modules}
        formats={formats}
        attachments={emailAttachments} // Pass the attachments
      />
      <ActivityModal
        isOpen={isActivityModalOpen}
        onClose={handleCloseActivityModal}
        parentId={id}
        parent="quotes"
        axiosInstance={axiosInstance}
        onActivitySaved={handleActivitySaved}
        currentUser={user}
      />
      
      <Modal
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-modal-title"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          {/* Header */}
          <Box className="pearl-popup-header"
            sx={{
              backgroundColor: colors.popupHeader.background,
              px: 4,
              py: 3,
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            <MDTypography
              id="delete-modal-title"
              variant="h6"
              component="h2"
              sx={{ color: '#FFFFFF' }}
            >
              Delete Quotation
            </MDTypography>
          </Box>

          {/* Content */}
          <Box sx={{ p: 4 }}>
            <MDTypography variant="body1" mb={3}>
              Are you sure you want to delete this quotation? This action cannot be undone.
            </MDTypography>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                onClick={handleCloseDeleteModal}
                variant="outlined"
                color="secondary"
                sx={{ marginRight: 2 }}
              >
                Cancel
              </MDButton>
              <MDButton
                onClick={handleDelete}
                variant="gradient"
                color="error"
              >
                Delete
              </MDButton>
            </MDBox>
          </Box>
        </Box>
      </Modal>

      {/* Feed Item Delete Confirmation Modal */}
      <Modal
        open={deleteConfirmOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="feed-delete-modal-title"
        aria-describedby="feed-delete-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          {/* Header */}
          <Box className="pearl-popup-header"
            sx={{
              backgroundColor: colors.popupHeader.background,
              px: 4,
              py: 3,
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            <MDTypography
              id="feed-delete-modal-title"
              variant="h6"
              component="h2"
              sx={{ color: '#FFFFFF' }}
            >
              Delete Message
            </MDTypography>
          </Box>

          {/* Content */}
          <Box sx={{ p: 4 }}>
            <MDTypography
              id="feed-delete-modal-description"
              variant="body1"
              mb={3}
              sx={{ color: '#34495e' }}
            >
              Are you sure you want to delete this message? This action cannot be undone.
            </MDTypography>

            <MDBox display="flex" justifyContent="flex-end" mt={3}>
              <MDButton
                onClick={handleDeleteCancel}
                variant="outlined"
                color="secondary"
                sx={{ marginRight: 2 }}
              >
                Cancel
              </MDButton>
              <MDButton
                onClick={handleDeleteConfirmOk}
                variant="gradient"
                color="error"
              >
                Delete
              </MDButton>
            </MDBox>
          </Box>
        </Box>
      </Modal>
    </DashboardLayout>
  );
}


export default QuotationDetail;